import React, { useEffect, useCallback, useState } from 'react'
import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes } from "@blueprintjs/core";
import { Button, ButtonGroup, AnchorButton, Callout, Overlay, Intent, H3, H4, Card, Icon, Elevation } from "@blueprintjs/core";
import { Popover, Menu, MenuDivider, MenuItem } from "@blueprintjs/core";
import Recorder from 'react-mp3-recorder'
import useWebSocket, { ReadyState } from 'react-use-websocket';
import Clock from 'react-live-clock';
import SortableTable from './components/table/SortableTable.tsx';
import { SelectColumnFilter, SelectColumnFilterAll } from "./components/table/Filter";
import { Bars } from 'react-loader-spinner'
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
  MultistepDialog,
  DialogStep,
  ButtonProps,
  RadioGroup,
  Radio,
  NumericInput,
  Label,
} from "@blueprintjs/core";
import PanelNom from './components/PanelNom.tsx';
import PanelEmail from './components/PanelEmail.tsx';
import PanelPassword from './components/PanelPassword.tsx';
import Home from './components/Home.tsx';
import PanelLogout from './components/PanelLogout.tsx';
import CardOpenVisio from './components/CardOpenVisio.tsx';
import CardDocument from './components/CardDocument.tsx';
import NewWindow from 'react-new-window'
import CardDocuments from './components/CardDocuments.tsx';
import { TabsDocuments } from './components/TabsDocuments.tsx';
import { TabsDocumentsEnseignant } from './components/TabsDocumentsEnseignant.tsx';
import { TabsEnseignants } from './components/TabsEnseignants.tsx';
import TableEnseignants from './components/componentTable/TableEnseignants.js';
import TableMatieres from './components/componentTable/TableMatieres.js';
import CardAteliers from './components/CardAteliers.tsx';
import { map, set, uniqueId } from 'lodash';
import CardEnseignantCnx from './components/CardEnseignantCnx.tsx';
import CardPourEnseignantCnx from './components/CardPourEnseignantCnx.tsx';
import { Checkbox } from '@material-ui/core';
import { MSG_VISIO } from './MessagesVisio.js';
import CardMesEleves from './components/CardMesEleves.tsx'
import CardMesEnregistrements from './components/CardMesEnregistrements.tsx'
import CardSuperAdmin from './components/CardSuperAdmin.tsx';
import CardAdminDistributeurs from './components/CardAdminDistributeurs.tsx';
import CardAdminClients from './components/CardAdminClients.tsx';

var frameurlimmediat = undefined;
var socket1 = undefined;
var _host_IP_DB="";
const toaster = Toaster.create({
  className: "my-toaster",
  position: Position.TOP_RIGHT,
  Intent: Intent.SUCCESS,
  timeout: 2000
});
const toasterrecord = Toaster.create({
  className: "my-toaster",
  icon: "fast-forward",
  position: Position.TOP_RIGHT,
  Intent: Intent.SUCCESS,
  timeout: 2000
});
toasterrecord.timeout = 2000;
toasterrecord.Intent = Intent.SUCCESS;
const locales = [
  {
    language: 'en',
    messages: {
      hello: 'Hello {name}!',
    }
  },
  {
    language: 'fr',
    messages: {
      hello: 'Bonjour {name}!',
    }
  }
];

const siteLanguage = 'fr';

function setChangeMaj(obj) {
  console.log(obj.id);
  datatable.map((it) => {
    if (it.selected.id == obj.id) it.selected.value = !it.selected.value;
  }
  )
  //data.filter((it)=>it.id==id)
}
const datatable = [
  { id: 1, teacher: "Eleve", selected: { id: 1, value: false }, name: 'PC1', iplocal: "192.168.1.2", macadress: "CE:34:54:65:78" },
  { id: 2, teacher: "Enseignant", selected: { id: 2, value: true }, name: 'PC2', iplocal: "192.168.1.3", macadress: "C3:34:54:65:79" },
  { id: 3, teacher: "Eleve", selected: { id: 3, value: false }, name: 'PC3', iplocal: "192.168.1.4", macadress: "C4:34:54:65:79" },
  { id: 4, teacher: "Eleve", selected: { id: 4, value: false }, name: 'PC4', iplocal: "192.168.1.4", macadress: "C4:34:54:65:79" },
  // Ajoutez d'autres lignes de données au besoin
];

function App() {
  const columns = [

    {
      Header: 'Rôle',
      accessor: 'teacher',
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      Header: 'Nom machine',
      accessor: 'name',
    },
    {
      Header: 'IP',
      accessor: 'iplocal',
    }
    ,
    {
      Header: 'Mac adresse',
      accessor: 'macadress',
    }
    ,
    {
      Header: 'Mise à jour',
      accessor: 'selected',
      filter: "includes",
      disableFilters: true,
      Cell: (props) => {
        return < Checkbox id={props.value.id} onChange={(ev) => { setChangeMaj(props.value) }} checked={props.value.value} {...props} />
      }
    }
    // Ajoutez d'autres colonnes au besoin
  ];



  function getsocketurl() {
    var hosttab = window.location.href.split(':');
    var host = hosttab[1].split('/')[2];
    host = "//" + host;
    if (hosttab.length > 2)
      host = host + ":" + hosttab[2].split('/')[0];
    return "wss:" + host + "/ws/general/";
  }
  function getparamurl() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get('id')
    if (id == undefined) return;
    if (id == "") return
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    formData.append('nickname', usernickname.nickname);
    formData.append('email', userinfo.username);
    formData.append('password', userpassword.password);

    setUserToken({ token: undefined })
    xhr.open('GET', '/api/public/logininvite?id=' + id)
    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function () {
      if (xhr.readyState == XMLHttpRequest.DONE) {

        if (xhr.status == 200) {
          var jsonResponse = JSON.parse(xhr.responseText);
          setUserToken({ token: jsonResponse.token })
          setUsernickname({ nickname: jsonResponse.nickname })
          setUserId(jsonResponse.id_user);
          setRefUserRole(jsonResponse.role);
          handleClickChangeSocketUrl(jsonResponse.id_user);
          if (jsonResponse.role == "teacher") { setTeacherid_select(jsonResponse.id_user); LoadDataUserForEnseignant(jsonResponse.id_user); }
          else loadStudentDocument(jsonResponse.id_user).then(documents => {
            //console.log(documents);
            setStudentDocument(documents);
            var obj = [];
            var objdate = [];
            documents.map((item) => {
              var st = { id: item.ID, id_matiere: item.id_matiere, title: item.title, date: item.date_record, data: item.url, type: item.type };
              obj.push(st);
              var dd = st.date.split(',');
              var nb = objdate.filter(st => st.datedujour == dd[0]).length
              var stitem2 = { datedujour: dd[0], creationdate: item.CreatedAt, selected: false, recordings: [] };
              if (nb == 0) objdate.push(stitem2);
              objdate.map((item2) => {
                if (item2.datedujour == dd[0]) item2.recordings.push(st);
              });
            });

            setRecordings(obj);
            filterStudentDocuments(objdate, select_matiere)
          })
          toaster.show({ icon: "person", intent: Intent.SUCCESS, timeout: 2000, message: "Connexion de " + jsonResponse.nickname + " réussie" });
          setIsConnected('none')
          setNavFilesVisible('flex');
          setIsConnected('none');
          localStorage.setItem("nickname", jsonResponse.nickname);// JSON.stringify(name));
          if (jsonResponse.role != "teacher") LoadDataClassesForEtudiant(jsonResponse.id_user);
          if (localip != "") setIplocal(localip, jsonResponse.id_user);

        }
        if (xhr.status == 500) { toaster.show({ icon: "warning-sign", intent: Intent.DANGER, timeout: 3000, message: "Identifiant ou mot de passe incorrect" }); }
        setUserPassword({})
      }

    }
    return setisOpenLogin(false)
  }
  const sckurl = getsocketurl();
  const isOpensArray = [false, false, false, false, false, false, false, false];
  const [isOpen, setIsOpen] = React.useState(isOpensArray);
  const [socketlabtice, setSocketlabtice] = React.useState(undefined);
  const [isforadminOpen, setIsForadminOpen] = React.useState(false);
  const [menuVisibility, setMenuVisible] = React.useState('none');
  const [isnotconnected, setIsConnected] = React.useState('flex');
  const [navFiles, setNavFilesVisible] = React.useState('none');
  const [isOpenLogin, setisOpenLogin] = React.useState(false);
  const [isOpenSign, setisOpenSign] = React.useState(false);
  const [isAdmin, setIsAdmin] = React.useState(0);
  const [mustRefresh, setMustRefresh] = React.useState(false);
  const [state, setState] = React.useState({});
  const [usernickname, setUsernickname] = React.useState({});
  const [select_matiere, setSelectMatiere] = React.useState(-1);
  const [matiereencours, setMatiereencours] = React.useState('');
  const [userinfo, setUserinfo] = React.useState({});
  const [userpassword, setUserPassword] = React.useState("");
  const [useridentifiantpassword, setUseridentifiantpassword] = React.useState({ identifiant: "", password: "" });
  const [usertoken, setUserToken] = React.useState({ token: undefined });
  const [isnotlabo, setIsnotlabo] = React.useState('none');
  const [isnotenseignant, setIsnotEnseignant] = React.useState('none');
  const [isnotdocument, setIsnotdocument] = React.useState('none');
  const [frameurl, setFrameUrl] = React.useState(undefined);
  const [usertype, setUserType] = React.useState(undefined);
  const [usernom, setUserNom] = React.useState(undefined);
  const [userprenom, setUserPrenom] = React.useState(undefined);
  const [userlicence, setUserLicence] = React.useState('');
  const [userrole, setUserRole] = React.useState('');
  const [ismespostes, setIsmespostes] = React.useState(false);
  const [userid, setUserId] = React.useState('');
  const [licence, setLicence] = React.useState({});
  const [useretablissement, setUserEtablissement] = React.useState('');
  const [pageid, setpageId] = React.useState('');
  const [recordtime, setRecordTime] = React.useState('00:00:00');
  const [ordrerecorder, setordreRecorder] = React.useState('');
  const [compteur, setCompteur] = React.useState(-1);
  const [memocompteur, setMemoCompteur] = React.useState(-1);
  const [recordings, setRecordings] = React.useState([]);
  const [recordingsbydate, setRecordingsbydate] = React.useState([]);
  const [aideenregistrementaudio, setAideenregistrementaudio] = React.useState(false);
  const [userconnected, setUserconnected] = React.useState([]);
  const [datastudent, setDataStudent] = React.useState([]);
  const thisdatastudent = React.useRef(datastudent);
  const thisuserrole = React.useRef(userrole);
  const [isInfoSystem, setIsInfoSystem] = React.useState('none');
  const [teacherid_select, setTeacherid_select] = React.useState('');
  const [groupe_user, setGroupe_user] = React.useState('');
  const [studentid_select, setStudentid_select] = React.useState('');
  const [classroom_code, setClassroom_code] = React.useState([]);
  const [classroom_name, setClassroom_name] = React.useState([]);
  const [classroom_name_all, setClassroom_name_all] = React.useState([]);
  const [has_type_classe_chariot, setHas_type_classe_chariot] = React.useState(false);
  const [localip, setLocalIp] = React.useState('');
  const [postermessage, setPostermessage] = React.useState(0);
  const [tabmessagesiframe, setTabMessageIframe] = React.useState([{}]);

  const [teacherautooverlay, setTeacherautooverlay] = React.useState(false);
  const [selected_visio, setSelected_visio] = React.useState(false);

  const [enseignantconnected, setEnseignantconnected] = React.useState(false);
  const [isteacherconnected, setIsTeacherconnected] = React.useState(false);
  const [deleterecord, setDeleterecord] = React.useState(-1);
  const [forcematiere, setForcematiere] = React.useState('');
  const [ordreenseignant, setOrdreenseignant] = React.useState('');
  const [parampclocal, setParampclocal] = React.useState('');


  const [recordermessage, setRecorderMessage] = React.useState("Démarrage")
  const [id_document, setId_document] = React.useState(-1)
  const [title_document, setTitleDocument] = React.useState("")

  //Data Enseignants et matieres
  const [data, setData] = React.useState([]);
  const [dataclassesetudiants, setDataClassesEtudiants] = React.useState([]);
  const [datamatieres, setDataMatieres] = React.useState([]);
  const [studentdocument, setStudentDocument] = React.useState([]);

  const [dataconnected, setDataconnected] = React.useState([]);

  const [socketUrl, setSocketUrl] = useState(sckurl);
  const [messageHistory, setMessageHistory] = useState([]);
  const [alldocuments, setAlldocuments] = useState([]);
  const [nb_student_cnx, setNb_student_cnx] = React.useState(0);
  const [labticetools, setLabticetools] = React.useState(false);
  const [hasLabtice, setHasLabtice] = React.useState(false);




  const { sendMessage, lastMessage, readyState, getWebSocket } = useWebSocket(socketUrl, {
    onOpen: () => console.log('opened'),
    //Will attempt to reconnect on all close events, such as server shutting down
    shouldReconnect: (closeEvent) => {
      var reco = true;
      console.log(socketUrl);
      var tb = socketUrl.split("-1");
      console.log(tb);
      if (tb == undefined) return true;
      if (tb.length > 1) { reco = false; } else { reco = true; } return reco
    },
  });
  const [nom_student, setNomStudent] = useState('');
  const [laststudentcnx, setLaststudentcnx] = useState('');


  const setRefDataStudent = (data) => {
    thisdatastudent.current = data;
    setDataStudent(data);
    setNb_student_cnx(data.length);
  };

  useEffect(() => {
    socket1 = new WebSocket("ws://127.0.0.1:5910/visu/");
    socket1.onopen = function () {
      console.log("success service labtice");
      setSocketlabtice(socket1);
      socket1.onmessage = function (msg) {
        console.log(msg);
        var tab = msg.data.split('*:');
        if (tab[0] == "ip") {
          setLocalIp(tab[1]);
          // setClassroom_name("Bureau Ixilos");
          socket1.send('get_classroom_code');
        }
        if (tab[0] == "classroom_code") {

          //setClassroom_code(tab[1].split('#*#'));
          //socket1.send('get_classroom_name');
          var jsonResponse = JSON.parse(tab[1]);
          console.log(jsonResponse);
          //var jsonResponse2 = JSON.parse(jsonResponse[0]);
          //console.log(jsonResponse2);
          var obj = [];
          obj.push(jsonResponse)
          socket1.send('get_classroom_name_all');
          setClassroom_code(obj);
          setClassroom_name(obj);
          loadParametrage(obj[0].code).then(obj2 => {
            obj[0].type_classe = obj2.type_classe;
            console.log(obj2);
            setClassroom_code(obj);
            setClassroom_name(obj);
          });

        }
        if (tab[0] == "classroom_name") {
          //var jsonResponse = JSON.parse(tab[1]);
          //setClassroom_name(jsonResponse);
        }
        if (tab[0] == "classroom_name_all") {
          var jsonResponse = JSON.parse(tab[1]);
          console.log(jsonResponse);
          var jsonResponse2 = JSON.parse(jsonResponse[0]);
          console.log(jsonResponse2);
          setClassroom_name_all(jsonResponse2);
        }
        if (tab[0] == "autologin") {
          setHasLabtice(true);
          setUsernickname({ nickname: tab[1] })
          setUserinfo({ username: tab[1] })
          setUserPassword({ password: 'auto' });
          handleSendCnxAutoLogin(tab[1], tab[1], 'auto');

        }
      }
      socket1.send('get_ip');
    }
  }, []);
  useEffect(() => {
    if (laststudentcnx != '') { getStudentnameById_select(laststudentcnx); setLaststudentcnx(''); }
  }, [datastudent]);
  const setRefUserRole = data => {
    thisuserrole.current = data;
    setUserRole(data);
  };
  const handleClickChangeSocketUrl = useCallback(
    (url) => {
      setSocketUrl(sckurl + url);
    },
    []
  );

  const handleTypeInfo = (jsonResponse) => {
    if (jsonResponse.type == "info") {
      if (userrole != "teacher") {
        if (jsonResponse.payload != undefined) {
          if (jsonResponse.payload.ordre != undefined) {
            if (jsonResponse.payload.ordre == "allinvisio_on") {
              handleOpenVisio(MSG_VISIO.OUVRIR_VISIO, "");
            }
            else
              if (jsonResponse.payload.ordre == "groupeinvisio_on") {
                if (jsonResponse.payload.peerId != undefined) {
                  var tab = jsonResponse.payload.peerId.split(",");
                  if (tab == undefined) return;
                  if (tab.length == 0) return;
                  //on récupère et enleve le groupe en bout de tableau
                  var groupe = tab.pop();

                  tab.map((item) => {
                    console.log("groupeinvisio_on");
                    console.log(item);
                    if (item == userid) {
                      handleOpenVisio(MSG_VISIO.OUVRIR_CONFERENCE, "", groupe);
                    }
                  });
                }
              }
              else
                if (jsonResponse.payload.ordre == "groupeinmatiere_on") {
                  if (jsonResponse.payload.peerId != undefined) {
                    var tab = jsonResponse.payload.peerId.split(",");
                    if (tab == undefined) return;
                    if (tab.length == 0) return;
                    //on récupère et enleve l'enseignant en bout de tableau
                    var id_enseigant = tab.pop();
                    //on récupère et enleve la matiere en bout de tableau
                    var id_matiere = tab.pop();

                    tab.map((item) => {
                      console.log("groupeinmatiere_on");
                      console.log(item);
                      if (item == userid) {
                        //handleOpenVisio(MSG_VISIO.OUVRIR_CONFERENCE,"",groupe);
                        handlesetTeacherid_select(id_enseigant);
                        handleSelectMatiere(id_matiere);
                        if (parseInt(id_matiere) < 0) id_matiere = -1;
                        setForcematiere(id_matiere);
                        handleChangeFromTeacher();

                      }
                    });
                  }
                }
                else
                  if (jsonResponse.payload.ordre == "groupeoutmatiere_on") {
                    if (jsonResponse.payload.peerId != undefined) {
                      var tab = jsonResponse.payload.peerId.split(",");
                      if (tab == undefined) return;
                      if (tab.length == 0) return;
                      //on récupère et enleve l'enseignant en bout de tableau
                      var id_enseigant = tab.pop();
                      //on récupère et enleve la matiere en bout de tableau
                      var id_matiere = tab.pop();

                      tab.map((item) => {
                        console.log("groupeoutmatiere_on");
                        console.log(item);
                        if (item == userid) {
                          //handleOpenVisio(MSG_VISIO.OUVRIR_CONFERENCE,"",groupe);
                          handlesetTeacherid_select('');
                          handleSelectMatiere(id_matiere);
                          //if(parseInt(id_matiere)<0) id_matiere=-1;
                          setForcematiere('');
                          handleChangeFromTeacher();
                        }
                      });
                    }
                  }
                  else
                    if (jsonResponse.payload.ordre == "groupeoutvisio_on") {
                      if (jsonResponse.payload.peerId != undefined) {
                        var tab = jsonResponse.payload.peerId.split(",");
                        if (tab == undefined) return;
                        if (tab.length == 0) return;
                        //on récupère et enleve le groupe en bout de tableau
                        var groupe = tab.pop();

                        tab.map((item) => {
                          console.log("groupeoutvisio_on");
                          console.log(item);
                          if (item == userid) {
                            handleOpenVisio(MSG_VISIO.FERMER_CONFERENCE, "", groupe);
                          }
                        });
                      }
                    }
                    else
                      if (jsonResponse.payload.ordre == "groupeinrecord_on") {
                        if (jsonResponse.payload.peerId != undefined) {
                          var tab = jsonResponse.payload.peerId.split(",");
                          if (tab == undefined) return;
                          if (tab.length == 0) return;
                          //on récupère et enleve le groupe en bout de tableau
                          var groupe = tab.pop();

                          tab.map((item) => {
                            console.log("groupeinrecord_on");
                            console.log(item);
                            if (item == userid) {
                              handleSetordreRecorder("record");
                              var stordre = ordreenseignant;
                              stordre = stordre + "_record";
                              setOrdreenseignant(stordre);
                            }
                          });
                        }
                      }
                      else
                        if (jsonResponse.payload.ordre == "groupeoutrecord_on") {
                          if (jsonResponse.payload.peerId != undefined) {
                            var tab = jsonResponse.payload.peerId.split(",");
                            if (tab == undefined) return;
                            if (tab.length == 0) return;
                            //on récupère et enleve le groupe en bout de tableau
                            var groupe = tab.pop();

                            tab.map((item) => {
                              console.log("groupeoutrecord_on");
                              console.log(item);
                              if (item == userid) {
                                handleSetordreRecorder("stop");
                                var stordre = ordreenseignant;
                                stordre = stordre.replaceAll("_record", "");
                                setOrdreenseignant(stordre);
                              }
                            });
                          }
                        }
                        else
                          if (jsonResponse.payload.ordre == "allinvisio_off") {
                            handleOpenVisio(MSG_VISIO.FERMER_VISIO, "");
                          }
                          else
                            if (jsonResponse.payload.ordre == "allincamera_on") {
                              if (jsonResponse.payload.peerId != undefined) {
                                var tab = jsonResponse.payload.peerId.split(",");
                                if (tab == undefined) return;
                                if (tab.length == 0) return;
                                tab.map((item) => {
                                  console.log("allincamera_on");
                                  console.log(item);
                                  if (item == userid) {
                                    var msg = JSON.stringify({
                                      error: false,
                                      message: "mute_video_off",
                                      source: 'app_user_main',
                                      id: userid,
                                      role: userrole
                                    })
                                    setPosterunmessage(msg);
                                  }
                                })
                              }
                            }
                            else
                              if (jsonResponse.payload.ordre == "allincamera_off") {
                                if (jsonResponse.payload.peerId != undefined) {
                                  var tab = jsonResponse.payload.peerId.split(",");
                                  if (tab == undefined) return;
                                  if (tab.length == 0) return;
                                  tab.map((item) => {
                                    console.log("allincamera_off");
                                    console.log(item);
                                    if (item == userid) {
                                      var msg = JSON.stringify({
                                        error: false,
                                        message: "mute_video_on",
                                        source: 'app_user_main',
                                        id: userid,
                                        role: userrole
                                      })
                                      setPosterunmessage(msg);
                                    }
                                  })
                                }
                              }
                              else
                                if (jsonResponse.payload.ordre == "streamcamera_on") {
                                  if (jsonResponse.payload.peerId != undefined) {
                                    var tab = jsonResponse.payload.peerId.split(",");
                                    if (tab == undefined) return;
                                    if (tab.length == 0) return;
                                    tab.map((item) => {
                                      console.log("streamcamera_on");
                                      console.log(item);

                                      var msg = JSON.stringify({
                                        error: false,
                                        message: "stream_mute_video_off",
                                        source: 'app_user_main',
                                        streamId: item,
                                        role: userrole
                                      })
                                      setPosterunmessage(msg);

                                    })
                                  }
                                }
                                else
                                  if (jsonResponse.payload.ordre == "streamcamera_off") {
                                    if (jsonResponse.payload.peerId != undefined) {
                                      var tab = jsonResponse.payload.peerId.split(",");
                                      if (tab == undefined) return;
                                      if (tab.length == 0) return;
                                      tab.map((item) => {
                                        console.log("streamcamera_off");
                                        console.log(item);

                                        var msg = JSON.stringify({
                                          error: false,
                                          message: "stream_mute_video_on",
                                          source: 'app_user_main',
                                          streamId: item,
                                          role: userrole
                                        })
                                        setPosterunmessage(msg);

                                      })
                                    }
                                  }
                                  else
                                    if (jsonResponse.payload.ordre == "streammicro_off") {
                                      if (jsonResponse.payload.peerId != undefined) {
                                        var tab = jsonResponse.payload.peerId.split(",");
                                        if (tab == undefined) return;
                                        if (tab.length == 0) return;
                                        tab.map((item) => {
                                          console.log("streammicro_off");
                                          console.log(item);

                                          var msg = JSON.stringify({
                                            error: false,
                                            message: "stream_mute_micro_on",
                                            source: 'app_user_main',
                                            streamId: item,
                                            role: userrole
                                          })
                                          setPosterunmessage(msg);

                                        })
                                      }
                                    }
                                    else
                                      if (jsonResponse.payload.ordre == "streammicro_on") {
                                        if (jsonResponse.payload.peerId != undefined) {
                                          var tab = jsonResponse.payload.peerId.split(",");
                                          if (tab == undefined) return;
                                          if (tab.length == 0) return;
                                          tab.map((item) => {
                                            console.log("streammicro_on");
                                            console.log(item);

                                            var msg = JSON.stringify({
                                              error: false,
                                              message: "stream_mute_micro_off",
                                              source: 'app_user_main',
                                              streamId: item,
                                              role: userrole
                                            })
                                            setPosterunmessage(msg);

                                          })
                                        }
                                      }
                                      else
                                        if (jsonResponse.payload.ordre == "allmicro_off") {
                                          if (jsonResponse.payload.peerId != undefined) {
                                            var tab = jsonResponse.payload.peerId.split(",");
                                            if (tab == undefined) return;
                                            if (tab.length == 0) return;
                                            tab.map((item) => {
                                              if (item == userid) {
                                                var msg = JSON.stringify({
                                                  error: false,
                                                  message: "mute_audio_on",
                                                  source: 'app_user_main',
                                                  id: userid,
                                                  role: userrole
                                                })
                                                setPosterunmessage(msg);
                                              }
                                            })
                                          }
                                        }
                                        else
                                          if (jsonResponse.payload.ordre == "allmicro_on") {
                                            if (jsonResponse.payload.peerId != undefined) {
                                              var tab = jsonResponse.payload.peerId.split(",");
                                              if (tab == undefined) return;
                                              if (tab.length == 0) return;
                                              tab.map((item) => {
                                                if (item == userid) {
                                                  var msg = JSON.stringify({
                                                    error: false,
                                                    message: "mute_audio_off",
                                                    source: 'app_user_main',
                                                    id: userid,
                                                    role: userrole
                                                  })
                                                  setPosterunmessage(msg);
                                                }
                                              })
                                            }
                                          }
                                          else
                                            if (jsonResponse.payload.ordre == "agrandir_video") {
                                              if (jsonResponse.payload.peerId != undefined) {
                                                var tab = jsonResponse.payload.peerId.split(",");
                                                //data.streamId recoit le streamId et les peerId
                                                //On recupere le streamId dans le premier item
                                                var lstreamId = tab[0];
                                                if (tab == undefined) return;
                                                if (tab.length == 0) return;
                                                tab.map((item) => {
                                                  if (item == userid) {
                                                    var msg = JSON.stringify({
                                                      error: false,
                                                      message: "agrandir_video",
                                                      source: 'app_user_main',
                                                      id: userid,
                                                      streamId: lstreamId,
                                                      role: userrole
                                                    })
                                                    setPosterunmessage(msg);
                                                  }
                                                })
                                              }
                                            }
                                            else
                                              if (jsonResponse.payload.ordre == "streamagrandir_video") {
                                                if (jsonResponse.payload.peerId != undefined) {
                                                  var tab = jsonResponse.payload.peerId.split(",");
                                                  //data.streamId recoit le streamId et les peerId
                                                  //On recupere le streamId dans le premier item
                                                  var lstreamId = tab[0];
                                                  if (tab == undefined) return;
                                                  if (tab.length == 0) return;
                                                  tab.map((item) => {

                                                    var msg = JSON.stringify({
                                                      error: false,
                                                      message: "agrandir_video",
                                                      source: 'app_user_main',
                                                      id: userid,
                                                      streamId: lstreamId,
                                                      role: userrole
                                                    })
                                                    setPosterunmessage(msg);

                                                  })
                                                }
                                              }
                                              else
                                                if (jsonResponse.payload.ordre == "reduire_video") {
                                                  if (jsonResponse.payload.peerId != undefined) {
                                                    var tab = jsonResponse.payload.peerId.split(",");
                                                    //data.streamId recoit le streamId et les peerId
                                                    //On recupere le streamId dans le premier item
                                                    var lstreamId = tab[0];
                                                    if (tab == undefined) return;
                                                    if (tab.length == 0) return;
                                                    tab.map((item) => {
                                                      if (item == userid) {
                                                        var msg = JSON.stringify({
                                                          error: false,
                                                          message: "agrandir_video",
                                                          source: 'app_user_main',
                                                          id: userid,
                                                          streamId: lstreamId,
                                                          role: userrole
                                                        })
                                                        setPosterunmessage(msg);
                                                      }

                                                    })
                                                  }
                                                }
                                                else
                                                  if (jsonResponse.payload.ordre == "streamreduire_video") {
                                                    if (jsonResponse.payload.peerId != undefined) {
                                                      var tab = jsonResponse.payload.peerId.split(",");
                                                      //data.streamId recoit le streamId et les peerId
                                                      //On recupere le streamId dans le premier item
                                                      var lstreamId = tab[0];
                                                      if (tab == undefined) return;
                                                      if (tab.length == 0) return;
                                                      tab.map((item) => {

                                                        var msg = JSON.stringify({
                                                          error: false,
                                                          message: "reduire_video",
                                                          source: 'app_user_main',
                                                          id: userid,
                                                          streamId: lstreamId,
                                                          role: userrole
                                                        })
                                                        setPosterunmessage(msg);

                                                      })
                                                    }
                                                  }
                                                  else
                                                    if (jsonResponse.payload.ordre == "minimize_video") {
                                                      if (jsonResponse.payload.peerId != undefined) {
                                                        var tab = jsonResponse.payload.peerId.split(",");
                                                        //On recupere le streamId dans le premier item
                                                        var lstreamId = tab[0];
                                                        if (tab == undefined) return;
                                                        if (tab.length == 0) return;
                                                        tab.map((item) => {
                                                          if (item == userid) {
                                                            var msg = JSON.stringify({
                                                              error: false,
                                                              message: "minimize_video",
                                                              source: 'app_user_main',
                                                              id: userid,
                                                              streamId: lstreamId,
                                                              role: userrole
                                                            })
                                                            setPosterunmessage(msg);
                                                          }
                                                        })
                                                      }
                                                    }
          }
        }
      }
      if (userrole == "teacher") {
        if (jsonResponse.payload != undefined) {
          if (jsonResponse.payload.ordre != undefined) {
            if (jsonResponse.payload.ordre == "selectteacher") {
              if (jsonResponse.payload.room != undefined) {
                if (jsonResponse.payload.room == userid) {
                  //console.log("Mon etudiant arrive:" datastudent)
                  if (jsonResponse.payload.peerId != undefined) {
                    var stnom2 = getStudentnameById_select(jsonResponse.payload.peerId);
                    if (stnom2 != "") toaster.show({ icon: "person", intent: Intent.SUCCESS, timeout: 5000, message: "l'étudiant " + stnom2 + " est dans la classe" });
                    else {
                      var idstudent = jsonResponse.payload.peerId;
                      setLaststudentcnx(idstudent);
                      LoadDataUserForEnseignant(userid);
                    }
                  }

                }
              }
            }
            else
              if (jsonResponse.payload.ordre == "groupeinvisio_on") {
                if (jsonResponse.payload.peerId != undefined) {
                  var tab = jsonResponse.payload.peerId.split(",");
                  if (tab == undefined) return;
                  if (tab.length == 0) return;
                  //on récupère et enleve le groupe en bout de tableau
                  var groupe = tab.pop();

                  tab.map((item) => {
                    console.log("groupeinvisio_on");
                    console.log(item);
                    if (item == userid) {
                      handleOpenVisio(MSG_VISIO.OUVRIR_CONFERENCE, "", groupe);
                    }
                  });
                }
              }
              else if (jsonResponse.payload.ordre == "quit") {
                if (jsonResponse.payload.room != undefined) {
                  if (jsonResponse.payload.room == userid) {
                    //console.log("Mon etudiant quit:" datastudent)
                    if (jsonResponse.payload.peerId != undefined) {
                      var stnom = getQuitStudentnameById_select(jsonResponse.payload.peerId);
                      toaster.show({ icon: "person", intent: Intent.DANGER, timeout: 5000, message: "l'étudiant " + stnom + " a quitté la classe" });
                    }

                  }
                }
              }
              else if (jsonResponse.payload.ordre == "appelfromstudent") {
                if (jsonResponse.payload.room != undefined) {
                  if (jsonResponse.payload.room == userid) {
                    //console.log("Mon etudiant quit:" datastudent)
                    if (jsonResponse.payload.peerId != undefined) {
                      var tabresp = jsonResponse.payload.peerId.split(',');
                      var streamId = tabresp[0];
                      var studentid = "";
                      if (tabresp.length > 0) studentid = tabresp[1];
                      if (studentid != "") {
                        // var stnom=getQuitStudentnameById_select(studentid);
                        var stnom = getStudentnameById_select(studentid);
                        toaster.show({ icon: "person", intent: Intent.PRIMARY, timeout: 5000, message: "l'étudiant " + stnom + " demande la parole" });
                        var msg = JSON.stringify({
                          error: false,
                          message: "appelfromstudent",
                          source: 'app_user_main',
                          streamId: streamId,
                          id: userid,
                          role: userrole
                        })
                        setPosterunmessage(msg);
                      }
                    }

                  }
                }
              }

          }
        }
      }
    }
  }

  const handleTypeRoomJoin = (jsonResponse) => {
    if (jsonResponse.type == "wsRoomJoin") {
      if (jsonResponse.payload != undefined) {
        if (jsonResponse.payload.metadata != undefined) {
          if (jsonResponse.payload.peerId == userid) {
            if (jsonResponse.payload.metadata != "sessiondejaouverte") {
              if (usernickname.nickname != undefined) handleClickSendMessage('{"type":"ready","payload":{"room":"general","nickname":"' + usernickname.nickname + '","peerId":"' + userid + '"}}');
            }
            else {
              console.log("metadata=sessiondejaouverte");
              handleClickChangeSocketUrl(-1);
              setTimeout(function () { }, 3000)
              {
                handleClickChangeSocketUrl(userid);
              }
            }
          }
          else {
            if (userrole != "teacher") {
              if (jsonResponse.payload.peerId == teacherid_select) {
                handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"' + teacherid_select + '","nickname":"' + usernickname.nickname + '","ordre":"selectteacher","peerId":"' + userid + '"}}');
              }
            }
          }
        }
      }
    }
  }
  useEffect(() => {
    const timer = setTimeout(() => {
      setRecordTime(fctCmpte());
    }, 1000);

    return () => clearTimeout(timer);
  });
  useEffect(() => {
    classroom_name_all.map((itclasse) => getTypeClasse(itclasse.code));
  }, [classroom_name_all.length != 0])
  useEffect(() => {
    console.log("ws");
    console.log(lastMessage);
    if (lastMessage !== null) {
      //if(usernickname.nickname==undefined)return;
      var jsonResponse = JSON.parse(lastMessage.data);
      console.log(jsonResponse);
      //sessiondejaouverte
      if (jsonResponse != null) {
        if (jsonResponse.type == "info") {
          if (jsonResponse.payload != undefined) {
            if (jsonResponse.payload.ordre != undefined) {
              if (jsonResponse.payload.ordre == "sessiondejaouverte") {
                if (jsonResponse.payload.peerId == userid) { handleLogout(true); toaster.show({ icon: "person", intent: Intent.DANGER, timeout: 5000, message: "La session était ouverte ailleurs. Reconnectez-vous" }); }
              }
            }
          }
        }
      }
      if (jsonResponse != null) {
        if (usernickname.nickname == undefined) return;
        handleTypeInfo(jsonResponse);
        handleTypeRoomJoin(jsonResponse);
        if (jsonResponse.type == "wsRoomLeave") {
          data.map((item) => {
            if (item.id_enseignant == jsonResponse.payload) item.etat = "Hors Ligne";
          });
          datastudent.map((item) => {
            if (item.ID == jsonResponse.payload) {
              if (item.etat == "En ligne") {
                var stnom = getQuitStudentnameById_select(item.ID);
                toaster.show({ icon: "person", intent: Intent.DANGER, timeout: 5000, message: "l'étudiant " + stnom + " a quitté la classe" });
              }
              item.etat = "Hors Ligne";
            }
          });
          if (usernickname.nickname != undefined) if (userid != '') handleClickSendMessage('{"type":"ready","payload":{"room":"general","nickname":"' + usernickname.nickname + '","peerId":"' + userid + '"}}');
        }

        if (jsonResponse.type == "users") if (jsonResponse.payload != null) {
          var tabcnx = Object.keys(jsonResponse.payload.nicknames);
          setUserconnected(tabcnx);
          if (userrole != "teacher") {
            //var tabcnx=Object.keys(jsonResponse.payload.nicknames);
            //setUserconnected(tabcnx);
            var memoidenseignant = "";
            var isChanged = false;
            for (var j = 0; j < tabcnx.length; j++)
              data.map((item) => {
                if (item.etat == null) item.etat = "Hors ligne";
                console.log(item);

                if (memoidenseignant != item.id_enseignant) if (item.id_enseignant == tabcnx[j]) if (item.etat != "En ligne") {
                  memoidenseignant = item.id_enseignant;
                  toaster.show({ icon: "person", intent: Intent.SUCCESS, timeout: 5000, message: "l'enseignant " + item.nom_enseignant + " est en ligne" });
                  //alert("l'enseignant " +  item.nom_enseignant + " est en ligne");

                  item.etat = "En ligne";
                  isChanged = true;
                  setIsTeacherconnected(true);


                } else {
                  memoidenseignant = item.id_enseignant;
                  isChanged = true;
                }
              });
            if (teacherid_select == "") if (teacherautooverlay == true) setEnseignantconnected(isChanged);
            if (isChanged) setDataconnected(data);
          }
          if (userrole == "teacher") {

          }
        }

      }
      setMessageHistory((prev) => prev.concat(lastMessage));
    }
  }, [lastMessage, setMessageHistory]);
  const handlerMessageiframe = event => {
    //console.log("from App2:");
    //console.log(event.data);
    //console.log(userid)
    if (event.data == undefined) return;
    if (event.data == "") return;
    /*if(event.data.source.includes("react-devtools"))return;
    if(event.data.source=="react-devtools-content-script")return
    if(event.data.source=="react-devtools-bridge")return
    if(event.data.source=="react-devtools-detector")return*/
    //if(!event.data.source.includes('{'))return;
    if (event.data.source != undefined) return;
    if (!event.data.includes('{')) return;

    console.log("from App:");
    console.log(event.data);
    const data = JSON.parse(event.data);
    console.log(data);
    if (data.message == undefined) return;
    if (data.message == "maximized") {
      if (data.payload != undefined) {
        if (thisuserrole.current == "teacher") {
          var id_stream = data.payload + "_" + data.peerId;
          //var id_stream=data.peerId;
          handleOpenVisio(MSG_VISIO.OUVRIR_CAMERA, [], id_stream);
          handleOpenVisio(MSG_VISIO.OUVRIR_MICROPHONE, [], id_stream);
        }
      }
    } else
      if (data.message == "minimized") {
        if (data.payload != undefined) {
          if (thisuserrole.current == "teacher") {
            var id_stream = data.payload + "_" + data.peerId;
            setTimeout(() => {
              handleOpenVisio(MSG_VISIO.FERMER_CAMERA, [], id_stream);
              handleOpenVisio(MSG_VISIO.FERMER_MICROPHONE, [], id_stream);
            }, 1000);
          }
        }
      } else
        if (data.message == "streams") {
          if (data.payload != undefined) {
            if (data.payload.localStreams != undefined) {
              if (data.payload.localStreams.desktop != undefined) {
                var streamId = data.payload.localStreams.desktop.streamId;
                var obj = [];
                thisdatastudent.current.map((item) => obj.push(item));
                handleOpenVisio(MSG_VISIO.AGRANDIR_VIDEO, obj, streamId);
              }
            }
          }
        }
        else
          if (data.message == "appelteacherfromstudent") {
            if (data.payload != undefined) {

              var streamId = data.payload;
              var obj = [];
              handleOpenVisio(MSG_VISIO.APPEL_TEACHER, obj, streamId);


            }
          }


  }
 /* useEffect(() => {
   // console.log("ws status");
   // console.log(readyState);
  //  console.log(connectionStatus);
  }, [readyState]);*/

  useEffect(() => {
    console.log("app_user start");
    getparamurl();
    if (window.chrome != undefined) if (window.chrome.webview != undefined) window.chrome.webview.postMessage('app_user start');
    //getipdb();
  }, []);
  useEffect(() => {
    userconnected.map((item) => {
      //console.log(item)
      datastudent.map((item2) => {
        if (item == item2.ID) {
          item2.status = "connected";
        }
      });
    });
  }, [userconnected]);

  useEffect(() => {
    window.addEventListener("message", handlerMessageiframe)
    return () => window.removeEventListener("message", handlerMessageiframe);
  }, [userid, teacherid_select]);

  useEffect(() => {
    if (frameurl != undefined) {
      console.log("frameurl" + frameurl);



      setTimeout(function () {
        var tab = frameurl.split('_');
        var msg = JSON.stringify({
          error: false,
          message: "ok",
          source: 'app_user_main',
          id: userid,
          role: userrole
        })
        if (tab.length > 1) {
          msg = JSON.stringify({
            error: false,
            message: "ok_conference",
            source: 'app_user_main',
            id: userid,
            role: userrole
          });
        }
        var childWindow = document.getElementById("iframe_visio");
        childWindow = childWindow.contentWindow;

        if (childWindow != undefined) childWindow.postMessage(msg, '*');
      }, 3000);

    }

  }, [frameurl]);

  useEffect(() => {
    if (postermessage <= 0) return;
    if (frameurl != undefined) {
      //console.log("poster un message:"+postermessage);
      var childWindow = document.getElementById("iframe_visio");
      if (childWindow != undefined) {
        childWindow = childWindow.contentWindow;
        var objmsg = [];
        tabmessagesiframe.map((item) => objmsg.push(item));
        setTimeout(() => {
          var msg = objmsg.pop();
          // console.log(msg)
          childWindow.postMessage(msg, '*');
          setTabMessageIframe(objmsg);
          // console.log(objmsg)
          setPostermessage(objmsg.length);
        }, 100);
        //setTabMessageIframe([]);
      }
    }


  }, [postermessage]);

  const getipdb = async () => {
    const response = await fetch('/api/public/getlocalipdb');
    _host_IP_DB = await response.text();
    //console.log(_host_IP_DB);
  }
  const setPosterunmessage = (msg) => {
    var objmsg = []
    tabmessagesiframe.map((item) => objmsg.push(item));
    objmsg.push(msg);
    setTabMessageIframe(objmsg);
    setPostermessage(objmsg.length);
  }
  const handleClickSendMessage = useCallback((message) => sendMessage(message), []);
  const connectionStatus = {
    [ReadyState.CONNECTING]: 'En attente de connexion',
    [ReadyState.OPEN]: 'Connecté',
    [ReadyState.CLOSING]: 'En fermeture de connexion',
    [ReadyState.CLOSED]: 'Déconnecté',
    [ReadyState.UNINSTANTIATED]: 'pas reconnu',
  }[readyState];
  const handle_select_document = (id_doc, title_doc) => {
    setId_document(id_doc);
    setTitleDocument(title_doc);
  }
  const fctCmpte = (() => {
    if (compteur > -1) setCompteur(compteur + 1);
    else return recordtime;
    var stcs = "";
    var stcm = "";
    var cpt = compteur;
    var cpts = cpt % 60;
    var cptm = cpt / 60;
    cptm = parseInt(cptm);
    if (cpts < 0) stcs = "00";
    else if (cpts < 10) stcs = "0" + cpts;
    else stcs = cpts;
    if (cptm < 0) stcm = "00";
    else if (cptm < 10) stcm = "0" + cptm;
    else stcm = cptm;
    return "00" + ":" + stcm + ":" + stcs
  })
  const handleOpen = function () {
    return setisOpenSign(true);
  }
  const handleOpenLogin = function () { return setisOpenLogin(true); }

  const loadParametrage = async (code) => {
    //if (obj.code=="")return undefined;
    //if (obj.code==undefined)return undefined;
    const response = await fetch('/api/public/getparametrage?code=' + code);
    const documents = await response.json();
    return documents;
  }
  const loadStudentDocument = async (id) => {
    const response = await fetch('/api/public/getstudentdocument?id_student=' + id);
    const documents = await response.json();
    return documents;
  }
  const getTypeClasse = async (code) => {
    const response = await fetch('/api/public/getparametrage?code=' + code);
    const type = await response.json();
    if (type.type_classe == "") setHas_type_classe_chariot(true);
    if (type.type_classe == "0") setHas_type_classe_chariot(true);
    var obj = [];
    classroom_name_all.map((itclasse) => { if (itclasse.code == type.code) { itclasse.type_classe = type.type_classe; } obj.push(itclasse); });
    console.log(obj);
    setClassroom_name_all(obj);
    return type;
  }
  const deleteStudentDocument = async (id) => {
    const response = await fetch('/api/public/delstudentdocument?id_document=' + id);
    // const documents = await response.json();
    return response;
  }
  const LoadDataUserForEnseignant = (id) => {
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");

    //var that=_this;
    //https://localhost:3000/api/public/getusersforenseignant?id_enseignant=39
    xhr.open('GET', '/api/public/getusersforenseignant?id_enseignant=' + id);

    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send();

    xhr.onreadystatechange = function () {

      if (xhr.readyState == XMLHttpRequest.DONE) {

        if (xhr.status == 200) {
          var jsonResponse = JSON.parse(xhr.responseText);
          if (jsonResponse != null) {
            //var jj = JSON.parse(jsonResponse[0]);
            console.log("LoadDataUserForEnseignant");
            console.log(jsonResponse);
            var obj = [];
            jsonResponse.map((item) => {
              /*var exist=false;
              datastudent.map((item2)=>
              {
                if (item.ID==item2.ID){obj.push(item2);exist=true;}
              });
              
              if(!exist)obj.push(item);*/
              obj.push(item);
            });
            setRefDataStudent(obj);
            //console.log(obj);
          }

          if (xhr.status == 404) { console.log({ message: "erreur" }); }
          if (xhr.status == 500) { console.log({ message: "erreur" }); }
        }

      }
    }
  }
  const wsServeurReady = function (index, iduser) {
    console.log("wsServeurReady" + index)
    if (usernickname.nickname != undefined) {
      if (iduser != '') handleClickSendMessage('{"type":"ready","payload":{"room":"general","nickname":"' + usernickname.nickname + '","peerId":"' + iduser + '"}}')
      else {
        iduser = userid;
        setTimeout((ev) => wsServeurReady(0, iduser), 3000)
      }
    }
  }
  const LoadDataMatieres = () => {
    //if(xhrencours)return;
    //var that=this;
    //setXhrEncours(true);
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");

    //var that=_this;
    xhr.open('GET', '/api/public/getclassroom?id_user=' + userid)

    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send();

    xhr.onreadystatechange = function () {

      if (xhr.readyState == XMLHttpRequest.DONE) {

        if (xhr.status == 200) {

          //console.log(xhr.responseText);
          var jsonResponse = JSON.parse(xhr.responseText);
          //console.log(jsonResponse)
          if (jsonResponse != null) {
            var jj = JSON.parse(jsonResponse[0]);
            var kk = { ID: jj[0].ID, nom_enseignant: jj[0].nom_enseignant, id_enseignant: jj[0].id_enseignant, email_enseignant: jj[0].email_enseignant, matiere: jj[0].matiere, code: jj[0].code, status: jj[0].status, visible: jj[0].visible }
            //console.log(jsonResponse[0].length);
            if (jj.length > 1) { for (var t = 0; t < jj.length; t++) { jj[t].status = "" }; kk.subRows = jj; kk.matiere = ""; }
            var jsonResponse2 = [kk];
            var jsonResponseMatieres = jj;
          }
          else { var jsonResponse2 = []; var jsonResponseMatieres = []; }
          console.log(jsonResponse2);
          //console.log(jsonResponse.length);
          if (jsonResponse != null) for (var i = 1; i < jsonResponse.length; i++) {
            var jj = JSON.parse(jsonResponse[i]);
            var kk = { ID: jj[0].ID, nom_enseignant: jj[0].nom_enseignant, id_enseignant: jj[0].id_enseignant, email_enseignant: jj[0].email_enseignant, matiere: jj[0].matiere, code: jj[0].code, status: jj[0].status, visible: jj[0].visible }
            if (jj.length > 1) { for (var t = 0; t < jj.length; t++) { jj[t].status = "" }; kk.subRows = jj; kk.matiere = ""; }
            console.log(kk)
            jsonResponse2 = jsonResponse2.concat(kk);
            jsonResponseMatieres = jsonResponseMatieres.concat(jj);
          }

          console.log(jsonResponse2);
          dataconnected.map((item) => {
            jsonResponse2.map((item2) => {
              if (item2.ID == item.ID) item2.status = item.etat;
            });
          });

          // setData(jsonResponse2);

          handleData(jsonResponseMatieres);
          // setMemoData(jsonResponse2);
          //toaster.show( {message:"Matière "+ uMatiere.matiere + " créée"});

        }
        if (xhr.status == 404) { console.log({ message: "erreur" }); }
        if (xhr.status == 500) { console.log({ message: "erreur" }); }


      }
      //setXhrEncours(false);

    }
  }
  const handleChangeFromTeacher = () => {
    LoadDataClassesForEtudiant(userid);
    LoadDataMatieres();
    /*loadStudentDocument(jsonResponse.id_user).then(documents=>
      {
        setStudentDocument(documents);
        var obj=[];
        var objdate=[];
        documents.map((item)=>{
          var st={id:item.ID,id_matiere:item.id_matiere,id_document:item.objectif, title:item.title,date:item.date_record,data:item.url,type:item.type};
          obj.push(st);
          var dd=st.date.split(',');
          var nb=objdate.filter(st=>st.datedujour == dd[0]).length
          var stitem2={datedujour:dd[0],creationdate:item.CreatedAt,selected:false,recordings:[]};
          if(nb==0)objdate.push(stitem2);
          objdate.map((item2)=>{
            if(item2.datedujour==dd[0]) item2.recordings.push(st);
          });
        });
        
        setRecordings(obj);
        filterStudentDocuments(objdate,select_matiere)
      })*/
  }
  const handleSendCnxLogin = function () {
    //toaster.show( {message:"login utilisateur: "+ userinfo.username+" - "+userpassword.password});
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    formData.append('nickname', usernickname.nickname);
    formData.append('email', userinfo.username);
    formData.append('password', userpassword.password);

    setUserToken({ token: undefined })
    xhr.open('POST', '/api/public/login')
    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function () {
      if (xhr.readyState == XMLHttpRequest.DONE) {

        if (xhr.status == 200) {
          var jsonResponse = JSON.parse(xhr.responseText);
          setUserToken({ token: jsonResponse.token })
          setUsernickname({ nickname: jsonResponse.nickname })
          setUserId(jsonResponse.id_user);
          setUserEtablissement(jsonResponse.etablissement);
          setRefUserRole(jsonResponse.role);
          handleClickChangeSocketUrl(jsonResponse.id_user);
          if (jsonResponse.role == "teacher") {
            setTeacherid_select(jsonResponse.id_user); LoadDataUserForEnseignant(jsonResponse.id_user);
            setIsmespostes(true);
            var lic = { type_produit: jsonResponse.type_produit, end_date: jsonResponse.end_date }
            setLicence(lic);
            localStorage.setItem("select_matiere_id", "");
            localStorage.setItem("selected_classe_id", "");
            localStorage.setItem("conference", "");
            localStorage.setItem("recordaudio", "");
            setTimeout((ev) => getAllDocuments(jsonResponse.id_user), 1000);

          } else
            if (jsonResponse.role == "superadmin") {
              setIsAdmin(2);
            }
            else
              if (jsonResponse.role == "admin") {
                setIsAdmin(3);
              }
              else loadStudentDocument(jsonResponse.id_user).then(documents => {
                //console.log(documents);
                setStudentDocument(documents);
                var obj = [];
                var objdate = [];
                documents.map((item) => {
                  var st = { id: item.ID, id_matiere: item.id_matiere, id_document: item.objectif, title: item.title, date: item.date_record, data: item.url, type: item.type };
                  obj.push(st);
                  var dd = st.date.split(',');
                  var nb = objdate.filter(st => st.datedujour == dd[0]).length
                  var stitem2 = { datedujour: dd[0], creationdate: item.CreatedAt, selected: false, recordings: [] };
                  if (nb == 0) objdate.push(stitem2);
                  objdate.map((item2) => {
                    if (item2.datedujour == dd[0]) item2.recordings.push(st);
                  });
                });

                setRecordings(obj);
                filterStudentDocuments(objdate, select_matiere)
              })
          toaster.show({ icon: "person", intent: Intent.SUCCESS, timeout: 2000, message: "Connexion de " + jsonResponse.nickname + " réussie" });
          setIsConnected('none')
          setNavFilesVisible('flex');
          setIsConnected('none');
          localStorage.setItem("nickname", jsonResponse.nickname);// JSON.stringify(name));
          if (jsonResponse.role != "teacher") LoadDataClassesForEtudiant(jsonResponse.id_user);
          if (localip != "") {
            setIplocal(localip, jsonResponse.id_user);
            if (socket1 != undefined) socket1.send('set_username:' + jsonResponse.nickname);
          }

        }
        if (xhr.status == 500) { toaster.show({ icon: "warning-sign", intent: Intent.DANGER, timeout: 3000, message: "Identifiant ou mot de passe incorrect" }); }
        setUserPassword({})
      }

    }
    return setisOpenLogin(false)
  }
  const handleSendCnxAutoLogin = function (stnickname, stemail, stpass) {
    //toaster.show( {message:"login utilisateur: "+ userinfo.username+" - "+userpassword.password});
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    formData.append('nickname', stnickname);
    formData.append('email', stemail);
    formData.append('password', stpass);

    setUserToken({ token: undefined })
    xhr.open('POST', '/api/public/login')
    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function () {
      if (xhr.readyState == XMLHttpRequest.DONE) {

        if (xhr.status == 200) {
          var jsonResponse = JSON.parse(xhr.responseText);
          setUserToken({ token: jsonResponse.token })
          setUsernickname({ nickname: jsonResponse.nickname.split('@')[0] })
          setUserId(jsonResponse.id_user);
          setUserEtablissement(jsonResponse.etablissement);
          setRefUserRole(jsonResponse.role);
          handleClickChangeSocketUrl(jsonResponse.id_user);
          var lic = { type_produit: jsonResponse.type_produit, end_date: jsonResponse.end_date }
          setLicence(lic);
          setHasLabtice(false);
          if (jsonResponse.role == "teacher") {
            setTeacherid_select(jsonResponse.id_user); LoadDataUserForEnseignant(jsonResponse.id_user);
            localStorage.setItem("select_matiere_id", "");
            localStorage.setItem("selected_classe_id", "");
            localStorage.setItem("conference", "");
            localStorage.setItem("recordaudio", "");
            setIsmespostes(true);

          } else
            if (jsonResponse.role == "superadmin") {
              setIsAdmin(2);
            }
            else
              if (jsonResponse.role == "admin") {
                setIsAdmin(3);
              }
              else loadStudentDocument(jsonResponse.id_user).then(documents => {
                //console.log(documents);
                setStudentDocument(documents);
                var obj = [];
                var objdate = [];
                documents.map((item) => {
                  var st = { id: item.ID, id_matiere: item.id_matiere, id_document: item.objectif, title: item.title, date: item.date_record, data: item.url, type: item.type };
                  obj.push(st);
                  var dd = st.date.split(',');
                  var nb = objdate.filter(st => st.datedujour == dd[0]).length
                  var stitem2 = { datedujour: dd[0], creationdate: item.CreatedAt, selected: false, recordings: [] };
                  if (nb == 0) objdate.push(stitem2);
                  objdate.map((item2) => {
                    if (item2.datedujour == dd[0]) item2.recordings.push(st);
                  });
                });

                setRecordings(obj);
                filterStudentDocuments(objdate, select_matiere)
              })
          toaster.show({ icon: "person", intent: Intent.SUCCESS, timeout: 2000, message: "Connexion de " + jsonResponse.nickname + " réussie" });
          setIsConnected('none')
          setNavFilesVisible('flex');
          setIsConnected('none');
          localStorage.setItem("nickname", jsonResponse.nickname);// JSON.stringify(name));
          if (jsonResponse.role != "teacher") LoadDataClassesForEtudiant(jsonResponse.id_user);
          if (localip != "") {
            setIplocal(localip, jsonResponse.id_user);
            if (socket1 != undefined) socket1.send('set_username:' + jsonResponse.nickname);
          }

        }
        if (xhr.status == 500) { setHasLabtice(false); toaster.show({ icon: "warning-sign", intent: Intent.DANGER, timeout: 3000, message: "Identifiant ou mot de passe incorrect" }); }
        setUserPassword({})
      }

    }
    return setisOpenLogin(false)
  }
  //Pour Signup
  const handleSendCnx = function () {
    if (usertype == 'teacher') {
      handleSendCreateEnseignant(usernickname.nickname.toLowerCase(), usernom, userinfo.username.toLowerCase(), userpassword.password, userlicence, '', '');
      return;
    }
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    formData.append('nickname', usernickname.nickname.toLowerCase());
    formData.append('email', userinfo.username.toLowerCase());
    formData.append('password', userpassword.password);

    xhr.open('POST', '/api/public/signup')
    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function () {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        if (xhr.status == 200) { toaster.show({ icon: "new-person", intent: Intent.SUCCESS, timeout: 2000, message: "Inscription de " + usernickname.nickname + " réussie" }); }
        if (xhr.status == 500) { alert("L'adresse Email existe déjà"); toaster.show({ icon: "warning-sign", intent: Intent.DANGER, timeout: 2000, message: "Vous êtes déjà inscrit : " + usernickname.nickname }); }
        setUserPassword({})
      }

    }
    return setisOpenSign(false)
  }
  //Pour Signup
  const handleSendCreateEnseignant = function (nickname, name, email, password, licence, matiere, etablissement) {

    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    formData.append('nickname', nickname);
    formData.append('name', name);
    formData.append('email', email.toLowerCase());
    formData.append('password', password);
    formData.append('role', "teacher");
    formData.append('code', "");
    formData.append('licence', licence);
    formData.append('matiere', matiere);
    formData.append('etablissement', etablissement);


    xhr.open('POST', '/api/public/createenseignant')
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function () {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        if (xhr.status == 200) { toaster.show({ icon: "new-person", intent: Intent.SUCCESS, timeout: 3000, message: "Inscription de " + usernickname.nickname + " réussie" }); }
        if (xhr.status == 500) { alert("L'adresse Email existe déjà"); toaster.show({ message: "Vous êtes déjà inscrit : " + usernickname.nickname }); }
        //setUserPassword({})

      }

    }
    return setisOpenSign(false)
  }
  const handleSendCreateUser = function (nickname, name, email, password, licence, matiere, etablissement, role) {

    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    formData.append('nickname', nickname);
    formData.append('name', name);
    formData.append('email', email.toLowerCase());
    formData.append('password', password);
    formData.append('role', role);
    formData.append('code', "");
    formData.append('licence', licence);
    formData.append('matiere', matiere);
    formData.append('etablissement', etablissement);


    xhr.open('POST', '/api/public/signup')
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function () {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        if (xhr.status == 200) { toaster.show({ icon: "new-person", intent: Intent.SUCCESS, timeout: 3000, message: "Inscription de " + usernickname.nickname + " réussie" }); }
        if (xhr.status == 500) { alert("L'adresse Email existe déjà"); toaster.show({ message: "Vous êtes déjà inscrit : " + usernickname.nickname }); }
        //setUserPassword({})

      }

    }
    return setisOpenSign(false)
  }
  const handleSendCreateAdmin = function (nickname, name, email, password, licence, matiere, etablissement, role) {

    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    formData.append('nickname', nickname);
    formData.append('name', name);
    formData.append('email', email.toLowerCase());
    formData.append('password', password);
    formData.append('role', role);
    formData.append('code', "");
    formData.append('licence', licence);
    formData.append('matiere', matiere);
    formData.append('id_createur', parseInt(userid));
    formData.append('etablissement', etablissement);

    var email = email;
    xhr.open('POST', '/api/public/signup')
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function () {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        if (xhr.status == 200) { toaster.show({ icon: "new-person", intent: Intent.SUCCESS, timeout: 3000, message: "Inscription de " + email + " réussie" }); }
        if (xhr.status == 500) { alert("L'identifiant existe déjà"); toaster.show({ message: "Vous êtes déjà inscrit : " + email }); }
        //setUserPassword({})

      }

    }
    return setisOpenSign(false)
  }
  const handleClose = () => setisOpenSign(false);
  const handleCloseLogin = () => setisOpenLogin(false);
  const handleChange = function (ev) { console.log(ev); }
  const handleChangeLogin = function (ev) { console.log(ev); }
  const handleSelectionGetLogin = function (identifiant, motdepasse) {

    if (identifiant == undefined) if (motdepasse == undefined) {
      handleSendCnxLogin();
      return;
    }

    if (identifiant != "") {
      setUsernickname({ nickname: identifiant })
      setUserinfo({ username: identifiant })
      if (motdepasse != "") setState({ isValidLogin: true }); else setState({ isValidLogin: undefined });
    }
    else {
      setState({ isValidLogin: undefined });
    }
    if (motdepasse != "") {
      setUserPassword({ password: motdepasse });
      if (identifiant != "") setState({ isValidLogin: true }); else setState({ isValidLogin: undefined });
    }
    else {
      setState({ isValidLogin: undefined });
    }

    /*
    formData.append('nickname', usernickname.nickname);
    formData.append('email', userinfo.username);
    formData.append('password', userpassword.password);
    */

  }
  const handleSelectionChangeLoginOld = function (ev) {
    if (ev == undefined) { setState({ value: undefined }); return; }
    var st = ev.value
    if (ev.id == 'step1') {
      if (st != "") {
        setState({ value: st.toLowerCase() });
        setUsernickname({ nickname: st.toLowerCase() })
      }
      else {
        setState({ value: undefined });
      }
    }
    if (ev.id == 'step2') {
      if (st != "") {
        setState({ value: st.toLowerCase() });
        setUserinfo({ username: st.toLowerCase() })
      }
      else {
        setState({ value: undefined });
      }
    }

    if (ev.id == 'pswd1') {
      setState({ value: st.toLowerCase() });
      setUserPassword({ password: st });
      setState({ isValidLogin: true });
    }

  }
  const handleLogout = function (isok) {
    setIsnotlabo('none'); setIsnotdocument('none'); setIsnotEnseignant('none');

    if (isok) {
      setUserRole('');
      setIsmespostes(false);
      handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"' + teacherid_select + '","nickname":"' + usernickname.nickname + '","ordre":"quit","peerId":"' + userid + '"}}');
      handleClickSendMessage('{"type":"hangUp","payload":{"room":"general","nickname":"' + usernickname.nickname + '","peerId":"' + userid + '"}}');
      setUserToken({ token: undefined });
      setUsernickname({ nickname: undefined });
      setNavFilesVisible('none');
      setFrameUrl(undefined);
      setIsnotlabo('none');
      setNomStudent('');
      toaster.show({ message: "Déconnexion réussie" });
      setIsConnected('flex');
      setUserId('');
      setpageId('');
      setTeacherid_select("");
      handleClickChangeSocketUrl(-1);
    }
  }
  const handleOpenVisio = function (index, payload, streamId = null) {
    console.log(userid);
    if (index == undefined) return;
    if (index == MSG_VISIO.FERMER_VISIO) {
      //setpageId('quitlabo');
      setNavFilesVisible('flex');
      setFrameUrl(undefined);
      setSelected_visio(false);
      return;
    }
    if (index == MSG_VISIO.FERMER_CONFERENCE) {
      //setpageId('quitlabo');
      setNavFilesVisible('flex');
      setFrameUrl(undefined);
      setSelected_visio(false);
      return;
    }
    if (index == MSG_VISIO.OUVRIR_VISIO) {
      if (teacherid_select == "") return;
      var url = "/call/" + teacherid_select;
      setFrameUrl(url);
      setSelected_visio(true);
      return;
    }
    if (index == MSG_VISIO.OUVRIR_CONFERENCE) {
      if (teacherid_select == "") return;
      if (streamId == "") return;
      var url = "/call/" + teacherid_select + "_" + streamId;
      setFrameUrl(url);
      setSelected_visio(true);
      setGroupe_user(streamId);
      return;
    }
    if (index == MSG_VISIO.OUVRIR_PROF_CONFERENCE) {
      if (streamId == "") return;
      if (userrole != "teacher") return;
      frameurlimmediat = "/call/" + userid + "_" + streamId;
      console.log(frameurlimmediat);
      setFrameUrl(frameurlimmediat);
      setSelected_visio(true);
      setGroupe_user(streamId);
      return;
    }
    if (index == MSG_VISIO.SET_TEACHER_CONNECTED) { setEnseignantconnected(true); return; }

    //mettre tous les étudiants dans la salle visio
    if (index == MSG_VISIO.ALL_IN_VISIO) { handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"allinvisio_on","peerId":"' + userid + '"}}'); return; }
    if (index == MSG_VISIO.ALL_OUT_VISIO) { handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"allinvisio_off","peerId":"' + userid + '"}}'); return; }
    if (index == MSG_VISIO.GROUPE_IN_MATIERE) {
      //mettre tous les étudiants dans la matière avec l'enseignant
      if (streamId != null) {
        var peers = [];
        peers.push(streamId);
        //le dernier item du tableau est le groupe
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"groupeinmatiere_on","peerId":"' + peers + '"}}');
        return;
      }
    }
    if (index == MSG_VISIO.GROUPE_OUT_MATIERE) {
      //mettre tous les étudiants dans la matière avec l'enseignant
      if (streamId != null) {
        var peers = [];
        peers.push(streamId);
        //le dernier item du tableau est le groupe
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"groupeoutmatiere_on","peerId":"' + peers + '"}}');
        return;
      }
    }
    if (index == MSG_VISIO.GROUPE_IN_VISIO) {
      //mettre tous les étudiants dans la salle visio selon leur groupe
      if (streamId != null) {
        var peers = [];
        peers.push(streamId);
        //le dernier item du tableau est le groupe
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"groupeinvisio_on","peerId":"' + peers + '"}}');
        return;
      }
    }
    if (index == MSG_VISIO.GROUPE_OUT_VISIO) {
      //Couper tous les étudiants dans la salle visio selon leur groupe
      if (streamId != null) {
        var peers = [];
        peers.push(streamId);
        //le dernier item du tableau est le groupe
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"groupeoutvisio_on","peerId":"' + peers + '"}}');
        return;
      }
    }
    if (index == MSG_VISIO.GROUPE_IN_RECORD) {
      //mettre tous les étudiants en enregistrement selon leur groupe
      if (streamId != null) {
        var peers = [];
        peers.push(streamId);
        //le dernier item du tableau est le groupe
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"groupeinrecord_on","peerId":"' + peers + '"}}');
        return;
      }
    }
    if (index == MSG_VISIO.GROUPE_OUT_RECORD) {
      //mettre tous les étudiants en enregistrement selon leur groupe
      if (streamId != null) {
        var peers = [];
        peers.push(streamId);
        //le dernier item du tableau est le groupe
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"groupeoutrecord_on","peerId":"' + peers + '"}}');
        return;
      }
    }

    //ouvrir les cameras
    if (index == MSG_VISIO.OUVRIR_CAMERA) {
      var peers = [];
      if (streamId != null) {
        peers.push(streamId);
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"streamcamera_on","peerId":"' + peers + '"}}');
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"streamagrandir_video","peerId":"' + peers + '"}}');
      }
      else {
        if (payload == "") return;
        payload.map((item) => {
          var item2 = item;
          if (item.selected) peers.push(item.ID);
        })
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"allincamera_on","peerId":"' + peers + '"}}');
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"agrandir_video","peerId":"' + peers + '"}}');
      }
      return;
    }
    //eteindre les cameras
    if (index == MSG_VISIO.FERMER_CAMERA) {
      var peers = [];
      //si la visio est une conference de groupe on ne fait rien
      var st = frameurlimmediat;
      var tabst = [];
      if (st != undefined) tabst = st.split('_');
      if (tabst.length > 1) return;

      if (streamId != null) {
        peers.push(streamId);
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"streamcamera_off","peerId":"' + peers + '"}}');
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"streamreduire_video","peerId":"' + peers + '"}}');
      }
      else {
        if (payload == "") return;
        payload.map((item) => {
          var item2 = item;
          if (item.selected) peers.push(item.ID);
        })
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"allincamera_off","peerId":"' + peers + '"}}');
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"reduire_video","peerId":"' + peers + '"}}');
      }
      return;
    }
    //ouvrir les microphones
    if (index == MSG_VISIO.OUVRIR_MICROPHONE) {
      var peers = [];
      if (streamId != null) {
        peers.push(streamId);
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"streammicro_on","peerId":"' + peers + '"}}');
      }
      else {
        if (payload == "") return;
        payload.map((item) => {
          var item2 = item;
          if (item.selected) peers.push(item.ID);
        })
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"allmicro_on","peerId":"' + peers + '"}}');
      }
      return;
    }
    //fermer les microphones
    if (index == MSG_VISIO.FERMER_MICROPHONE) {

      var peers = [];
      //si la visio est une conference de groupe on ne fait rien
      var st = frameurlimmediat;
      var tabst = [];
      if (st != undefined) tabst = st.split('_');
      if (tabst.length > 1) return;
      if (streamId != null) {
        peers.push(streamId);
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"streammicro_off","peerId":"' + peers + '"}}');
      }
      else {
        if (payload == "") return;
        var nb = 0;
        payload.map((item) => {
          var item2 = item;
          if (item.selected) { peers.push(item.ID); nb++; }
        })

        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"allmicro_off","peerId":"' + peers + '"}}');
      }
      return;
    }
    //Agrandir une fenêtre
    if (index == MSG_VISIO.AGRANDIR_VIDEO) {
      if (streamId != null) {
        var peers = [];
        //le premier element est le streamid
        peers.push(streamId);
        if (payload == "") return;
        var nb = 0;
        payload.map((item) => {
          var item2 = item;
          if (item.selected) { peers.push(item.ID); nb++; }
        })
        //si pas d'étudiants de selectionnés on prend tous ceux en ligne

        if (nb == 0) {
          datastudent.map((item) => {
            if (item.etat == "En ligne") {
              peers.push(item.ID);
            }
          })
        }
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"agrandir_video","peerId":"' + peers + '"}}');
      }
      return;
    }
    //REDUIRE VIDEO
    if (index == MSG_VISIO.REDUIRE_VIDEO) {
      if (streamId != null) {
        var peers = [];
        //le premier element est le streamid
        peers.push(streamId);
        if (payload == "") return;
        var nb = 0;
        payload.map((item) => {
          var item2 = item;
          if (item.selected) { peers.push(item.ID); nb++; }
        })
        //si pas d'étudiants de selectionnés on prend tous ceux en ligne

        if (nb == 0) {
          datastudent.map((item) => {
            if (item.etat == "En ligne") {
              peers.push(item.ID);
            }
          })
        }
        handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"general","nickname":"' + usernickname.nickname + '","ordre":"reduire_video","peerId":"' + peers + '"}}');
      }
      return;
    }
    //L'étudiant appel l'enseignant
    if (index == MSG_VISIO.APPEL_TEACHER) {
      if (streamId != null) {
        var peers = [];
        //le premier element est le streamid
        peers.push(streamId);
        peers.push(userid);
        peers.push(teacherid_select);
        //if(payload=="")return;
        if (teacherid_select != '') handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"' + teacherid_select + '","nickname":"' + usernickname.nickname + '","ordre":"appelfromstudent","peerId":"' + peers + '"}}');
      }

    }
    return;

    //setNavFilesVisible('none');
    //this.props.history.push(url),
    //history.push(url);
  }
  const showRedirige = (url) => {
    if (url != undefined) {
      console.log("url:" + url)
      //window.location=url;
      const varstyle = "style='width:100%;height:100%;display:block;position: absolute;border: 0;z-index:1'";
      return <div style={{ width: '100%', height: '100%', display: 'block', position: 'absolute', border: '0' }} dangerouslySetInnerHTML={{ __html: "<iframe id='iframe_visio'" + varstyle + "  src='" + url + "' />" }} />;
    }

  }
  const getEnseignantnameById_select = (id) => {
    var nom_enseignant = "";
    data.map((item) => {

      if (item.id_enseignant == id) if (nom_enseignant == "") nom_enseignant = item.nom_enseignant;

    });
    return nom_enseignant;
  }
  const getStudentnameById_select = (id) => {
    if (id == null) return;
    var nom = "";
    setNomStudent("");
    var nb = 0;

    /*data.map((item)=>{
      
      if(item.id_enseignant==id)if(nom_enseignant=="")nom_enseignant=item.nom_enseignant;
    
    });*/
    datastudent.map((item) => {
      if (item.etat == undefined) item.etat = "";
      if (item.ID == id) {
        nom = item.nickname;
        item.etat = "En ligne";
      }
    })
    datastudent.map((item) => {
      if (item.etat == "En ligne") {
        nb++;
      }
    })
    setNb_student_cnx(nb);
    setNomStudent(nom);
    return nom;
  }
  const getQuitStudentnameById_select = (id) => {
    var nom = ""
    var nom_other = ""
    var nb = 0;
    setNomStudent("")
    /*data.map((item)=>{
      
      if(item.id_enseignant==id)if(nom_enseignant=="")nom_enseignant=item.nom_enseignant;
    
    });*/
    datastudent.map((item) => {
      if (item.ID == id) {
        nom = item.nickname;
        item.etat = "Hors ligne";
      }
    })
    datastudent.map((item) => {
      if (item.etat == "En ligne") {
        nom_other = item.nickname;
        nb++;
      }
    })
    setNb_student_cnx(nb);
    setNomStudent(nom_other);
    return nom;
  }

  const handlesetTeacherid_select = (id) => {
    if (id > -1) {
      setTeacherid_select(id);
      handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"' + id + '","nickname":"' + usernickname.nickname + '","ordre":"selectteacher","peerId":"' + userid + '"}}');
    }
    else {
      handleClickSendMessage('{"type":"info","payload":{"room":"general"},"payloadinfo":{"room":"' + teacherid_select + '","nickname":"' + usernickname.nickname + '","ordre":"quit","peerId":"' + userid + '"}}');
      setTeacherid_select("");
    }
    getEnseignantnameById_select(id);
  }
  const handleSelectionChange = function (ev) {
    if (ev == undefined) { setState({ value: undefined }); return; }

    console.log(ev);
    var st = ev.value
    //console.log(st);
    //pour l enregistrement
    //value est la licence
    if (ev.tag == "licence_ok") { setUserLicence(st); setUserType('teacher'); setState({ value: ev.tag }); return; }
    if (ev.selectedIndex == "1") { setUserType('student'); setState({ value: st }); }
    if (ev.selectedIndex == "2") { setUserType('teacher'); setState({ value: undefined }); }
    if (ev.id == 'stepN1') {
      if (st == "") {
        //setState({value:st});
        //setUsernickname({nickname:st})
        setUserNom(undefined)
        setState({ value: undefined });
        return;
      }
      else {
        setUserNom(st)
        if (userprenom != undefined) setState({ value: "ok" });
      }
      setUsernickname({ nickname: st + "." + userprenom })
      setUserinfo({ username: st + "." + userprenom })
    }

    if (ev.id == 'stepN2') {
      if (st == "") {
        //setState({value:st});
        //setUsernickname({nickname:st})
        setUserPrenom(undefined)
        setState({ value: undefined });
        return;
      }
      else {
        setUserPrenom(st)
        if (usernom != undefined) setState({ value: "ok" });
      }
      setUsernickname({ nickname: usernom + "." + st })
      setUserinfo({ username: usernom + "." + st })
    }

    //Pour le login
    if (ev.id == 'step1') {
      if (st != "") {
        setState({ value: st });
        setUsernickname({ nickname: st })
      }
      else {
        setState({ value: undefined });
      }
    }
    if (ev.id == 'step2') {
      if (st != "") {
        setState({ value: st });
        setUserinfo({ username: st })
      }
      else {
        setState({ value: undefined });
      }
    }

    if (ev.id == 'pswd1') {
      setState({ value: st });
    }
    if (ev.id == 'pswd2') {
      if (state.value == st) {
        setState({ isValidSignin: true });
        setUserPassword({ password: st });
      }

    }
  }
  const AfterUpload = (jsonresp) => {
    var obj = [];
    var objdate = [];
    recordings.map((item) => {
      obj.push(item);
    });
    recordingsbydate.map((item) => {
      objdate.push(item);
    });
    //url_video_zoom_saved
    //var st={id:jsonresp.ID, title:"Enregistrement",date:jsonresp.date,data:URL.createObjectURL(blob)};
    var st = { id: jsonresp.id_file, id_matiere: jsonresp.id_matiere, id_document: jsonresp.id_document, title: jsonresp.title_document, date: jsonresp.date, data: jsonresp.filename, type: jsonresp.type };
    obj.push(st);
    setRecordings(obj);
    var dd = st.date.split(',');
    var nb = objdate.filter(st => st.datedujour == dd[0]).length
    var stitem2 = { datedujour: dd[0], creationdate: '', selected: false, recordings: [] };
    if (nb == 0) objdate.push(stitem2);
    objdate.map((item2) => {
      if (item2.datedujour == dd[0]) item2.recordings.push(st);
    });
    filterStudentDocuments(objdate, select_matiere);
  }
  const sortByKey = (array, key) => {
    return array.sort((a, b) => {
      let x = a[key];
      let y = b[key];

      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }
  const filterStudentDocuments = (objdate, idm) => {
    objdate.map((item2) => {
      var nb = 0;
      item2.timestamp = new Date(item2.creationdate).getTime() / 1000;
      item2.visible = true
      item2.recordings.map((item3) => {
        if (item3.id_matiere == idm) { item3.visible = true; nb++; } else { item3.visible = false; }
      })
      if (nb == 0) item2.visible = false;

    });
    objdate = sortByKey(objdate, 'timestamp');
    objdate = objdate.reverse();
    setRecordingsbydate(objdate);
  }

  const uploadrecordtext = async (stjson, id_doc, title_doc) => {
    const form = new FormData();
    var blob = new Blob([stjson], { type: 'application/json' });
    var objform = [];
    var date1 = new Date();
    var stdate = date1.toLocaleString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });

    objform.push({ ordre: "recordstudentdocumenttext", id_student: userid, id_matiere: select_matiere, date_record: stdate, type: "text" })

    form.append("uploadfile", blob, userid + "_" + id_doc + ".jsontext");
    form.append("ordre", "recordstudentdocumenttext");
    form.append("id_student", userid);
    form.append("id_matiere", select_matiere);
    form.append("date_record", stdate);
    form.append("title", title_doc);
    form.append("id_document", id_doc);
    form.append("type", "text");


    const response = await fetch("/uploadstext", {
      // credentials: "include",
      method: "POST",
      body: form,
    });
    const jsons = await response.json();
    return jsons;
  }

  const _onUploadtext = (stjson, id_doc, title_doc) => {
    handle_select_document(id_doc, title_doc);
    uploadrecordtext(stjson, id_doc, title_doc).then(json => AfterUpload(json));
  }
  const _onRecordingComplete = (blob) => {
    uploadrecord(blob).then(json => AfterUpload(json))
  }
  const uploadrecord = async (blob) => {
    const form = new FormData();
    var objform = [];
    var date1 = new Date();
    var stdate = date1.toLocaleString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });

    objform.push({ ordre: "recordstudentdocument", id_student: userid, id_matiere: select_matiere, date_record: stdate, type: "audio" })
    //form.append("file[]", blob, "record.mp3");
    form.append("uploadfile", blob, "record.mp3");
    form.append("ordre", "recordstudentdocument");
    form.append("id_student", userid);
    form.append("id_matiere", select_matiere);
    form.append("date_record", stdate);
    form.append("title", title_document);
    form.append("id_document", id_document);
    form.append("type", "audio");


    const response = await fetch("/uploads", {
      // credentials: "include",
      method: "POST",
      body: form,
    });
    const jsons = await response.json();
    return jsons;
  }
  const handleSelectPage = (page, opt) => {
    if (page == "cours") { if (dataclassesetudiants.length == 0) { LoadDataClassesForEnseignant(userid); } return; }
    if (page == "mesdocuments") { setIsnotlabo('none'); setIsnotEnseignant('none'); setIsnotdocument('flex'); }
    if (opt == 1)
      if (page == "mesdocuments") {
        var data2 = []
        data.map((item) => {
          if (item.id_enseignant == teacherid_select) data2 = data2.concat(item);

        });
        setData(data2);
      }
    if (opt == 0)
      if (page == "mesdocuments") {
        console.log(data);
        console.log(dataconnected);
        console.log(data.length);
        console.log(dataconnected.length);
        if (data.length < dataconnected.length) setData(dataconnected);
      }
    if (opt == -1)
      if (page == "mesdocuments") {
        setIsnotdocument('none');
      }
    setpageId(page);
  }

  const handleData = (ldata) => {
    setData(ldata);
  }
  const handleDataMatiereEnseignant = (mat_data) => {
    setDataMatieres(mat_data);
  }
  const handleDataClasseEtudiants = (classes_data) => {
    setDataClassesEtudiants(classes_data);
    console.log(classes_data);
  }

  const LoadDataClassesForEtudiant = (id) => {
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");

    var that = this;
    xhr.open('GET', 'api/public/getmesclasses?id_user=' + id);

    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send();

    xhr.onreadystatechange = function () {

      if (xhr.readyState == XMLHttpRequest.DONE) {

        if (xhr.status == 200) {
          var jsonResponse = JSON.parse(xhr.responseText);
          if (jsonResponse != null) {
            //var jj = JSON.parse(jsonResponse[0]);
            console.log("LoadDataClassesForEtudiant");
            console.log(jsonResponse);
            var obj = [];
            jsonResponse.map((itemclasse) => {
              var stuser = "_" + id + "_";
              if (itemclasse.id_students.includes(stuser)) obj.push(itemclasse);
            });
            setDataClassesEtudiants(obj);
          }
        }
        if (xhr.status == 404) { console.log({ message: "erreur" }); }
        if (xhr.status == 500) { console.log({ message: "erreur" }); }
      }

    }
  }
  const LoadDataClassesForEnseignant = (id) => {
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");

    var that = this;
    xhr.open('GET', '/api/public/getclassesetudiants?id_enseignant=' + id);

    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send();

    xhr.onreadystatechange = function () {

      if (xhr.readyState == XMLHttpRequest.DONE) {

        if (xhr.status == 200) {
          var jsonResponse = JSON.parse(xhr.responseText);
          if (jsonResponse != null) {
            //var jj = JSON.parse(jsonResponse[0]);
            console.log("LoadDataClassesForEnseignant");
            console.log(jsonResponse);
            var obj = [];

            jsonResponse.map((item) => {
              var tabstudents = item.id_students.split('_');
              var tab2 = [];
              tabstudents.map((it) => {
                datastudent.map((it2) => {
                  if (it2.ID == it) tab2.push(it2);
                })
              })
              item.selected = false;
              item.visible = true;
              item.students = tab2;
              obj.push(item);
            });

            handleDataClasseEtudiants(obj);
          }
        }
        if (xhr.status == 404) { console.log({ message: "erreur" }); }
        if (xhr.status == 500) { console.log({ message: "erreur" }); }
      }

    }
  }
  const handleSetordreRecorder = (stordre) => {
    if (stordre == "record") {
      toasterrecord.show({ icon: "record", intent: Intent.SUCCESS, timeout: 2000, message: "L'enregistrement a démarré" });
      setCompteur(1);
      setordreRecorder('record');
    }
    if (stordre == "play") {
      setCompteur(0);
      setordreRecorder('play');
    }
    if (stordre == "stop") {
      toasterrecord.show({ icon: "stop", intent: Intent.SUCCESS, timeout: 2000, message: "Arrêt" });
      setCompteur(-1);
      setordreRecorder('stop');
    }
    if (stordre == "pause") {
      setCompteur(-2);
      if (ordrerecorder == 'pauseon') {
        toasterrecord.show({ icon: "pause", intent: Intent.SUCCESS, timeout: 2000, message: "Reprise de l'enregistrement" });
        setordreRecorder('pauseoff');
        setCompteur(memocompteur)
      }
      else {
        toasterrecord.show({ icon: "pause", intent: Intent.SUCCESS, timeout: 2000, message: "l'enregistrement est en pause" });
        setMemoCompteur(compteur);
        setordreRecorder('pauseon');
      }
    }
  }
  const _onRecordingError = (err) => {
    console.log('recording error', err)
  }
  const EffacerEnregistrement = (id) => {
    var obj = [];
    var objdate = [];
    recordings.map((item) => {
      if (item.id != id) obj.push(item);
    });
    setRecordings(obj);
    recordingsbydate.map((item) => {
      var obj2 = [];
      item.recordings.map((item2) => {
        if (item2.id != id) obj2.push(item2);
      });
      if (obj2.length > 0) objdate.push({ datedujour: item.datedujour, creationdate: item.CreatedAt, selected: item.selected, recordings: obj2 });
    });
    //setRecordingsbydate(objdate);
    filterStudentDocuments(objdate, select_matiere)
    deleteStudentDocument(id);
  }

  const handleCardEleves = (retour, payload) => {
    if (retour == 1) toaster.show({ icon: "info-sign", intent: Intent.SUCCESS, timeout: 2000, message: "La classe est sauvegardée" });
    if (retour == 2) toaster.show({ icon: "info-sign", intent: Intent.SUCCESS, timeout: 2000, message: "Le mot de passe est effacé" });
    if (retour == 3) toaster.show({ icon: "info-sign", intent: Intent.SUCCESS, timeout: 2000, message: "La classe est effacée" });
  }

  const handleSelectMatiere = (id) => {
    setSelectMatiere(id);
    var objdate = [];
    recordingsbydate.map((item) => {
      objdate.push(item);
    });
    data.map((item) => {
      if (item.ID == id) setMatiereencours(item.matiere)
    })
    filterStudentDocuments(objdate, id);
    // console.log("matieres_selected:"+id)
  }
  const setIplocaltmp = (ev) => {
    setLocalIp(ev.target.innerText);
  }
  const setIplocal = async (ip, userid) => {
    const response = await fetch('/api/public/setlocalip?id_user=' + userid + "&iplocal=" + ip);
    console.log(response);
  }
  const getAllDocuments = async (userid) => {
    const response = await fetch('/api/public/getalldocumentforenseignant?id_enseignant=' + userid);
    const jsons = await response.json();
    setAlldocuments(jsons);
    console.log(jsons);
  }

  const getpclocalCustom = (classroom_code, matiere) => {
    var param = "";
    if (classroom_code == 0 && matiere == 0) {
      param = "add_poste=true";
      param = param + "&nbre=0" + "&id_enseignant=" + userid + "&localip=" + localip + "&name=" + usernickname.nickname; setParampclocal(param);
      param = param + "&salle=personnalisée";
      param = param + "&tk=" + usertoken.token;
      var host_pays = window.location.host;
      var url_host = "http://51.178.137.114/interfaces/interface/index.html?";//"http://164.132.43.81/wb/app_interface/index.html?";
      if (host_pays.includes('labtice.ch')) url_host = "http://195.15.213.52/interfaces/interface/index.html?";
      if(_host_IP_DB!="")url_host = "http://"+_host_IP_DB+"/interfaces/interface/index.html?";
      window.open(url_host + param, "_blank");
      return;
    }
  }
  const getpclocal = async (classroom_code, matiere) => {
    if (classroom_code == "") return;
    var param = "";
    const response = await fetch('/api/public/getusersbycode?code=' + classroom_code);
    const jsons = await response.json();
    console.log(jsons);

    var nbre = 0;
    jsons.map((item) => {
      if (item.iplocal != "") {
        //var param="";

        if (item.iplocal != localip) {
          nbre++;
          param = param + "ip" + nbre + "=" + item.iplocal + "&name" + nbre + "=" + item.nickname + "&";
        }

      }
    });
    //if(nbre>0){
    param = param + "nbre=" + nbre + "&id_enseignant=" + userid + "&localip=" + localip + "&name=" + usernickname.nickname;
    setParampclocal(param);
    param = param + "&salle=" + matiere + "&code=" + classroom_code;
    param = param + "&tk=" + usertoken.token;
    var host_pays = window.location.host;
    //51.178.137.114
    //51.83.97.90
    var url_host = "http://51.178.137.114/interfaces/interface/index.html?";//var url_host="http://164.132.43.81/wb/app_interface/index.html?";
    if (host_pays.includes('labtice.ch')) url_host = "http://195.15.213.52/interfaces/interface/index.html?";
    if(_host_IP_DB!="")url_host = "http://"+_host_IP_DB+"/interfaces/interface/index.html?";
    window.open(url_host + param, "_blank");
    // }
  }
  const fromChildren = (stordre, stvalue) => {
    if (stordre == "loadstudentdocument") {
      loadStudentDocument(stvalue).then(documents => {
        //console.log(documents);
        setStudentDocument(documents);
        var obj = [];
        var objdate = [];
        documents.map((item) => {
          var st = { id: item.ID, id_matiere: item.id_matiere, title: item.title, date: item.date_record, data: item.url, type: item.type };
          obj.push(st);
          var dd = st.date.split(',');
          var nb = objdate.filter(st => st.datedujour == dd[0]).length
          var stitem2 = { datedujour: dd[0], creationdate: item.CreatedAt, selected: false, recordings: [] };
          if (nb == 0) objdate.push(stitem2);
          objdate.map((item2) => {
            if (item2.datedujour == dd[0]) item2.recordings.push(st);
          });
        });

        setRecordings(obj);
        filterStudentDocuments(objdate, select_matiere)
      })
      return;
    }
  }
  const onChangeForAdmin = (ev) => {
    console.log(ev);
    //setIsAdmin(1);
    if (ev.target.value == "super super admin voulu") setIsAdmin(1);
  }
  const onChangeIdentifiant = (identifiant, password, etablissement) => {
    // var valeur=ev.target.value;
    //if(valeur=="")return;
    var passw = password;
    var obj = { identifiant: identifiant, password: passw, etablissement: etablissement };
    console.log(obj);
    setUseridentifiantpassword(obj);
  }
  const onChangePassword = (ev) => {
    var valeur = ev.target.value;
    if (valeur == "") return;
    var identi = useridentifiantpassword.identifiant;
    var obj = { identifiant: identi, password: valeur };
    setUseridentifiantpassword(obj);
  }


  const homeprops = { userid, pageid, userrole, nom_student, frameurl, isnotenseignant, isnotdocument, isnotlabo, usernickname, usertoken, isOpenSign, isOpenLogin, state, navFiles, isnotconnected, menuVisibility, usernickname, userprenom, usernom, usertype, ordrerecorder, compteur, fromChildren, handleSetordreRecorder, handleOpenVisio, handleLogout, handleSendCnx, handleSendCnxLogin, handleSelectionChange, handleOpen, handleClose, handleChange, handleOpenLogin, handleCloseLogin, handleChangeLogin, handleSelectionGetLogin }
  const mesenregistrementsprops = { isnotlabo, matiereencours, recordings, EffacerEnregistrement, recordingsbydate, userid }

  return (
    <div>
      {isAdmin == 10 ? <SortableTable columns={columns} data={datatable} /> : null}
      {isAdmin == 0 ? <div style={{ height: '100%' }}>
        <div style={{ display: 'block', padding: '0px 10px 0px', height: '100%' }}>
          {userrole != "teacher" ? <div>{showRedirige(frameurl)}</div> : null}
          {userrole != "teacher" ? <Navbar style={{ display: 'block', margin: '0px 0 10px', position: 'fixed', zIndex: 1000, backgroundColor: "#444", color: "#fff" }}>
            <NavbarGroup align={Alignment.LEFT}>
              <NavbarHeading onClick={(ev) => { if (isInfoSystem == 'none') setIsInfoSystem('block'); else setIsInfoSystem('none'); }}><span style={{ marginRight: 7 }}>LabTice</span><Clock format={'HH:mm:ss'} ticking={true} /></NavbarHeading>
              <NavbarDivider />

              <Button className={Classes.MINIMAL} style={{ color: "#fff" }} icon="person" text={usertoken.token == undefined ? "Connexion" : usernickname.nickname} onClick={(ev) => { ev.preventDefault(); handleLogout(false); if (usertoken.token != undefined) setpageId('logout'); else handleOpenLogin() }} />
              {userrole != "teacher" ? <Button style={{ display: navFiles, color: "#fff" }} className={Classes.MINIMAL} icon="inherited-group" text="Mes enseignants" onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('mesenseignants'); setIsnotlabo('none'); setIsnotEnseignant('flex'); setIsnotdocument('none'); } }} /> : null}
              {userrole == "teacher" ? <Button style={{ display: navFiles, color: "#fff" }} className={Classes.MINIMAL} icon="briefcase" text="Mes matières" onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('matieres'); setIsnotlabo('none'); setIsnotEnseignant('flex'); setIsnotdocument('none'); } }} /> : null}
              {userrole != "teacher" ? <Button style={{ display: navFiles, color: "#fff" }} className={Classes.MINIMAL} icon="document" text="Mes documents" onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { handleSelectPage("mesdocuments", 0); } }} /> : null}
              {userrole == "teacher" ? <Button style={{ display: navFiles, color: "#fff" }} className={Classes.MINIMAL} icon="manual" text="Mes cours" onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('cours'); handleSelectPage('cours'); setIsnotlabo('none'); setIsnotEnseignant('none'); setIsnotdocument('flex'); } }} /> : null}
              {/*userrole=="teacher"?<Button style={{display:navFiles}} className={Classes.MINIMAL} icon="inherited-group" text="Mes étudiants" onClick={(ev)=>{ev.preventDefault();if(usertoken.token!=undefined){setpageId('mesetudiants');setIsnotlabo('none');setIsnotEnseignant('none');setIsnotdocument('none');}}} />:null*/}
              {/*<Button style={{display:navFiles}} className={Classes.MINIMAL} icon="headset" text="Le Labo" onClick={(ev)=>{ev.preventDefault();if(usertoken.token!=undefined){setpageId('labo');setIsnotlabo('block');setIsnotEnseignant('none');setIsnotdocument('none');}}} />*/}
              {/*<Button style={{display:frameurl==undefined?'none':'flex'}} intent={Intent.DANGER} className={Classes.MINIMAL} icon="headset" text="Fermer la visio" onClick={(ev)=>{setpageId('quitlabo');ev.preventDefault();setNavFilesVisible('flex');setFrameUrl(undefined);}} />*/}
              <Recorder
                ordre={ordrerecorder}
                onRecordingComplete={_onRecordingComplete}
                onRecordingError={_onRecordingError}
              />
              {/*<Toaster className= "my-toaster"  position={Position.TOP_RIGHT} Intent={Intent.SUCCESS}  timeout={2000}><Toast timeout={2000} icon="fast-forward" message={recordermessage} Intent={Intent.SUCCESS}/></Toaster>*/}
              {(isnotconnected == 'none' && select_matiere > 0) ? <ButtonGroup style={{ marginLeft: 4 }} minimal={false} large={true}>
                <Button icon="record" intent={Intent.DANGER} disabled={ordrerecorder == 'pauseon' || compteur > 0} onClick={() => { toasterrecord.show({ icon: "record", intent: Intent.SUCCESS, timeout: 2000, message: "L'enregistrement a démarré" }); setCompteur(1); setordreRecorder('record') }}></Button>
                <Button icon="pause" intent={Intent.SUCCESS} disabled={compteur == -1 || ordreenseignant.includes("record")} onClick={() => { setCompteur(-2); if (ordrerecorder == 'pauseon') { toasterrecord.show({ icon: "pause", intent: Intent.SUCCESS, timeout: 2000, message: "Reprise de l'enregistrement" }); setordreRecorder('pauseoff'); setCompteur(memocompteur) } else { toasterrecord.show({ icon: "pause", intent: Intent.SUCCESS, timeout: 2000, message: "l'enregistrement est en pause" }); setMemoCompteur(compteur); setordreRecorder('pauseon'); } }}></Button>
                <Button icon="stop" intent={Intent.WARNING} disabled={ordrerecorder == 'pauseon' || compteur <= 0 || ordreenseignant.includes("record")} onClick={() => { toasterrecord.show({ icon: "stop", intent: Intent.SUCCESS, timeout: 2000, message: "Arrêt de l'enregistrement" }); setCompteur(-1); setordreRecorder('stop'); }}></Button>
                <AnchorButton onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('labo'); setIsnotlabo('block'); setIsnotEnseignant('none'); setIsnotdocument('none'); } }} rightIcon="play">{recordtime}</AnchorButton>
              </ButtonGroup> : <div></div>}
            </NavbarGroup>
          </Navbar> :
            <Navbar style={{ display: 'block', margin: '0px 0 10px', position: 'fixed', zIndex: 1000, backgroundColor: "#444", color: "#fff" }}>
              <NavbarGroup align={Alignment.LEFT}>
                <NavbarHeading onClick={(ev) => { if (isInfoSystem == 'none') setIsInfoSystem('block'); else setIsInfoSystem('none'); }}><span style={{ marginRight: 7 }}>LabTice</span><Clock format={'HH:mm:ss'} ticking={true} /></NavbarHeading>
                <NavbarDivider style={{ color: "#fff" }} />

                <Button style={{ color: "#fff" }} className={Classes.MINIMAL} icon="person" text={usertoken.token == undefined ? "Connexion" : usernickname.nickname} onClick={(ev) => { ev.preventDefault(); handleLogout(false); if (usertoken.token != undefined) setpageId('logout'); else handleOpenLogin() }} />
                <Popover content={<Menu>
                  <MenuItem icon="cross" text="Fermer" />
                  <MenuDivider style={{ color: "#fff" }} />
                  <MenuItem icon="briefcase" text="Mes matières" onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('matieres'); setIsnotlabo('none'); setIsnotEnseignant('flex'); setIsnotdocument('none'); } }} />
                  <MenuItem icon="manual" text="Mes cours" onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('cours'); handleSelectPage('cours'); setIsnotlabo('none'); setIsnotEnseignant('none'); setIsnotdocument('flex'); } }} />
                  {/*<MenuItem icon="inherited-group" text="Mes étudiants" onClick={(ev)=>{ev.preventDefault();if(usertoken.token!=undefined){setpageId('mesetudiants');setIsnotlabo('none');setIsnotEnseignant('none');setIsnotdocument('none');}}} />*/}

                </Menu>} position={Position.BOTTOM}>
                  <Button className={Classes.MINIMAL} style={{ userSelect: 'none', color: "#fff" }} icon="layers">Gestion</Button>
                </Popover>
                {/*<Button style={{display:navFiles}} className={Classes.MINIMAL} icon="headset" text="Le Labo" onClick={(ev)=>{ev.preventDefault();if(usertoken.token!=undefined){setpageId('mesetudiantslabo');setIsnotlabo('none');setIsnotEnseignant('none');setIsnotdocument('none');}}} />*/}
                {userrole == "teacher" ? classroom_name.length > 0 ?
                  <Popover content={<Menu>
                    <MenuItem icon="cross" text="Fermer" />
                    <MenuDivider />
                    {classroom_name.map((it) => it.type_classe != "2" ? <MenuItem style={{ display: navFiles }} className={Classes.MINIMAL} icon="desktop" text={it.matiere} onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('labo_local'); getpclocal(it.code, it.matiere); setIsnotlabo('none'); setIsnotEnseignant('none'); setIsnotdocument('none'); } }} /> : null)}
                    <MenuDivider />
                    {has_type_classe_chariot ? <MenuItem icon="plus" text="Tous" >
                      {classroom_name_all.map((it) => (it.type_classe == "" || it.type_classe == "0") ? it.type_classe != "2" ? <MenuItem style={{ display: navFiles }} className={Classes.MINIMAL} icon="desktop" text={it.matiere} onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('labo_local'); getpclocal(it.code, it.matiere); setIsnotlabo('none'); setIsnotEnseignant('none'); setIsnotdocument('none'); } }} /> : null : null)}
                    </MenuItem> : null}
                    {has_type_classe_chariot ? <MenuDivider /> : null}
                    {has_type_classe_chariot ? <MenuItem style={{ display: navFiles }} className={Classes.MINIMAL} icon="desktop" text="Personnalisés" onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('labo_local'); getpclocalCustom(0, 0); setIsnotlabo('none'); setIsnotEnseignant('none'); setIsnotdocument('none'); } }} /> : null}
                  </Menu>} position={Position.BOTTOM}>
                    <Button style={{ display: navFiles, color: "#fff" }} className={Classes.MINIMAL} icon="desktop" text="Mes postes" />
                  </Popover>
                  : null : null}
                {/*<Button style={{display:frameurl==undefined?'none':'flex'}} intent={Intent.DANGER} className={Classes.MINIMAL} icon="headset" text="Fermer la visio" onClick={(ev)=>{setpageId('quitlabo');ev.preventDefault();setNavFilesVisible('flex');setFrameUrl(undefined);}} />*/}
                <Recorder
                  ordre={ordrerecorder}
                  onRecordingComplete={_onRecordingComplete}
                  onRecordingError={_onRecordingError}
                />
                {/*<Toaster className= "my-toaster"  position={Position.TOP_RIGHT} Intent={Intent.SUCCESS}  timeout={2000}><Toast timeout={2000} icon="fast-forward" message={recordermessage} Intent={Intent.SUCCESS}/></Toaster>*/}
                {(isnotconnected == 'none' && select_matiere > 0) ? <ButtonGroup style={{ marginLeft: 4 }} minimal={false} large={true}>
                  <Button icon="record" intent={Intent.DANGER} disabled={ordrerecorder == 'pauseon' || compteur > 0} onClick={() => { toasterrecord.show({ icon: "record", intent: Intent.SUCCESS, timeout: 2000, message: "L'enregistrement a démarré" }); setCompteur(1); setordreRecorder('record') }}></Button>
                  <Button icon="pause" intent={Intent.SUCCESS} disabled={compteur == -1 || ordreenseignant.includes("record")} onClick={() => { setCompteur(-2); if (ordrerecorder == 'pauseon') { toasterrecord.show({ icon: "pause", intent: Intent.SUCCESS, timeout: 2000, message: "Reprise de l'enregistrement" }); setordreRecorder('pauseoff'); setCompteur(memocompteur) } else { toasterrecord.show({ icon: "pause", intent: Intent.SUCCESS, timeout: 2000, message: "l'enregistrement est en pause" }); setMemoCompteur(compteur); setordreRecorder('pauseon'); } }}></Button>
                  <Button icon="stop" intent={Intent.WARNING} disabled={ordrerecorder == 'pauseon' || compteur <= 0 || ordreenseignant.includes("record")} onClick={() => { toasterrecord.show({ icon: "stop", intent: Intent.SUCCESS, timeout: 2000, message: "Arrêt de l'enregistrement" }); setCompteur(-1); setordreRecorder('stop'); }}></Button>
                  <AnchorButton onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('labo'); setIsnotlabo('block'); setIsnotEnseignant('none'); setIsnotdocument('none'); } }} rightIcon="play">{recordtime}</AnchorButton>
                </ButtonGroup> : <div></div>}
              </NavbarGroup>
            </Navbar>}
          {ismespostes == true ? userrole == "teacher" ? classroom_name.length > 0 ? <div style={{ position: 'relative', top: 55 }}><Card style={{ backgroundColor: "#b7bcbf" }}>
            <div>
              {classroom_name.map((it) => it.type_classe != "2" ? <div><H5>Travailler avec ma salle</H5><Card interactive={true} style={{ fontSize: 22, userSelect: 'none', cursor: 'pointer' }} onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('labo_local'); getpclocal(it.code, it.matiere); setIsnotlabo('none'); setIsnotEnseignant('none'); setIsnotdocument('none'); } }} ><Icon size={30} style={{ marginRight: 10 }} icon="desktop"></Icon>{it.matiere}<span style={{ marginLeft: 50 }}><Icon size={30} style={{ marginRight: 10 }} icon="barcode"></Icon>{it.code}</span></Card></div> : null)}
              <p></p>
              {has_type_classe_chariot ? <H5>Choisir une autre salle</H5> : null}
              {classroom_name_all.map((it) => (it.type_classe == "0" || it.type_classe == "") ? it.type_classe != "2" ? <Card interactive={true} style={{ fontSize: 22, userSelect: 'none', cursor: 'pointer', margin: '4px 0' }} onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('labo_local'); getpclocal(it.code, it.matiere); setIsnotlabo('none'); setIsnotEnseignant('none'); setIsnotdocument('none'); } }} ><Icon size={30} style={{ marginRight: 10 }} icon="desktop"></Icon>{it.matiere}<span style={{ marginLeft: 50 }}><Icon size={30} style={{ marginRight: 10 }} icon="barcode"></Icon>{it.code}</span></Card> : null : null)}
              <p></p>
              {has_type_classe_chariot ? <H5>Composer votre salle</H5> : null}
              {has_type_classe_chariot ? <Card interactive={true} style={{ fontSize: 22, userSelect: 'none', cursor: 'pointer', margin: '4px 0' }} onClick={(ev) => { ev.preventDefault(); if (usertoken.token != undefined) { setpageId('labo_local'); getpclocalCustom(0, 0); setIsnotlabo('none'); setIsnotEnseignant('none'); setIsnotdocument('none'); } }} ><Icon size={30} style={{ marginRight: 10 }} icon="desktop"></Icon>Personnalisée</Card> : null}
              {licence.type_produit == "pro" ?
                <Card style={{ marginTop: 50, backgroundColor: "#eee" }}>
                  <span><Button onClick={(ev => setLabticetools(!labticetools))} style={{ backgroundColor: '#444', color: '#fff' }} icon={labticetools ? "minus" : "plus"} /><H5 style={{ marginTop: -25, marginLeft: 40 }}>Les outils complémentaires de Labtice Pro</H5></span>
                  {labticetools ? <div>
                    <Card style={{ marginTop: 15 }}><H5 style={{ marginLeft: -7 }}>Créer des contenus audios avec Labtice Création</H5>
                      <p><u>Avec Labtice Création, vous pouvez :</u></p>
                      <p>-Enregistrer votre voix sur une bande vierge.</p>
                      <p>-Insérer des blancs dans un document audio.</p>
                      <p>-Insérer une consigne, des questions, des phrases à trous.</p>
                      <p>-Transcrire un document audio ou vidéo vers du texte avec synchronisation.</p>
                      <p>-Créer des captures d'écrans vidéos.</p>
                      {/*<Button style={{backgroundColor: '#444', color: '#fff'}} icon="application" onClick={(ev)=>{var host_pays = window.location.host; var url_host="http://51.83.97.90/interfaces/interface_creation/";if(host_pays.includes('labtice.ch'))url_host="http://195.15.213.52/interfaces/interface_creation/";window.open(url_host,"_blank");}}>Ouvrir Labtice Création</Button>*/}
                      <Button style={{ backgroundColor: '#444', color: '#fff' }} icon="application" onClick={(ev) => { var host_pays = window.location.host; var url_host = "http://51.178.137.114/interfaces/interface_creation/"; if (host_pays.includes('labtice.ch')) url_host = "http://195.15.213.52/interfaces/interface_creation/"; if(_host_IP_DB!="")url_host = "http://"+_host_IP_DB+"/interfaces/interface_creation/";socket1.send("ouvrir_url" + url_host); }}>Ouvrir Labtice Création</Button>
                    </Card>
                    <Card style={{ marginTop: 15 }}><H5 style={{ marginLeft: -7 }}>Corriger les exercices de vos apprenants avec Labtice Correcteur</H5>
                      <p>-Ecouter l'enregistrement du document laissé par votre apprenant</p>
                      <p>-Voir la saisie écrite demandé dans votre exercice</p>
                      <p>-Exporter en PDF votre correction écrite</p>
                      <Button style={{ backgroundColor: '#444', color: '#fff' }} icon="application" onClick={(ev) => { var host_pays = window.location.host; var url_host = "http://51.178.137.114/interfaces/correcteur/"; if (host_pays.includes('labtice.ch')) url_host = "http://195.15.213.52/interfaces/correcteur/";if(_host_IP_DB!="")url_host = "http://"+_host_IP_DB+"/interfaces/correcteur/"; socket1.send("ouvrir_url" + url_host); }}>Ouvrir Labtice Correcteur</Button>
                    </Card>
                  </div> : null}

                </Card> : null}
            </div></Card></div> : null : null : null}
          {userrole != "teacher" ? <CardEnseignantCnx selected_visio={selected_visio} handleSelectPage={handleSelectPage} handleOpenVisio={handleOpenVisio} handlesetTeacherid_select={handlesetTeacherid_select} nom_enseignant={getEnseignantnameById_select(teacherid_select)} /> : <div></div>}
          {/*userrole=="teacher"?<CardPourEnseignantCnx selected_visio={selected_visio} nb_student_cnx={nb_student_cnx} datastudent={datastudent} handleSelectPage={handleSelectPage} handleOpenVisio={handleOpenVisio}  nom_student={nom_student}/>:<div></div>*/}
          {/*userrole=="teacher"?<div style={{paddingTop:'50px',position:'relative'}}></div>:null*/}
          <div style={{ display: isInfoSystem, paddingTop: 0 }}>
            <Card>
              <div>{readyState == ReadyState.OPEN ? <a>En ligne</a> : <a>Hors ligne</a>}</div>
              <div>{window.location.host} </div>
              <div id="iplocal" onClick={(ev) => setIplocaltmp(ev)}>{localip}</div>
              <div><span onClick={(ev) => setIsForadminOpen(!isforadminOpen)}>Connexion avec le serveur: {connectionStatus}</span></div>
              <div style={{ display: 'none' }}><span>Nombre d'utilisateur(s) connecté(s): {userconnected.length}</span></div>
              {licence.type_produit != undefined ? <div>
                <div><span><Icon style={{ marginRight: 10 }} icon="application"></Icon>Labtice {licence.type_produit.toUpperCase()}</span></div>
                <div><span><Icon style={{ marginRight: 10 }} icon="calendar"></Icon>Licence valide juqu'au {new Date(parseInt(licence.end_date)).toLocaleDateString()}</span></div>
              </div> : null
              }
              {/*isforadminOpen?<input onChange={(ev)=>onChangeForAdmin(ev)}></input>:null*/}
              {/*<div><span>message du système: </span> 
          <ul>
            {messageHistory.map((message, idx) => (
              <li><span key={idx}>{message ? message.data : null}</span></li>
            ))}
          </ul>
            </div>*/}
            </Card>
          </div>
          <Overlay isOpen={hasLabtice}>
            <Card style={{ height: 150, margin: '60px calc( 50% - 270px)' }}>
            <Bars  height="80"  width="300"  color="#444"  ariaLabel="bars-loading"  wrapperStyle={{}}  wrapperClass=""  visible={true}  />
              <div style={{ padding: 20, marginTop: 4, color: '#444', borderRadius: 10 }}>Connection automatique en cours, patientez ...</div></Card>
          </Overlay>
          <Overlay isOpen={enseignantconnected} className={Classes.OVERLAY_SCROLL_CONTAINER} >
            <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%', margin: '60px 25%' }}>

              <div>
                {isteacherconnected ? <H3>Un ou plusieurs enseignant(s) sont en ligne</H3> : <div><H3>Aucun de vos enseignants est en ligne</H3></div>}
              </div>

              {isteacherconnected ? <p>Choisissez avec quel enseignant vous voulez vous connecter.</p> : <p></p>}
              <ul style={{ listStyle: "none", padding: 0 }}>
                {dataconnected.map(item => (

                  <li>
                    {item.etat == "En ligne" ? <Button key={item.id_enseignant} style={{ width: '100%', marginTop: '4px' }} onClick={(ev) => { ev.preventDefault(); handlesetTeacherid_select(item.id_enseignant); setEnseignantconnected(false) }} intent={Intent.SUCCESS}>{item.nom_enseignant}</Button> : <div></div>}
                  </li>
                ))}
              </ul>
              <div>
                <img src="" />
              </div>
              <br />
              <div style={{ justifyContent: 'space-between' }} className={Classes.DIALOG_FOOTER_ACTIONS}>
                <span><Checkbox onClick={(ev) => { setTeacherautooverlay(!teacherautooverlay) }} checked={!teacherautooverlay}></Checkbox><span>Ne plus m'avertir</span></span>
                <Button intent={Intent.DANGER} onClick={(ev) => { ev.preventDefault(); setEnseignantconnected(false) }} style={{ margin: "" }}>
                  Fermer
                </Button>


              </div>
            </div>
          </Overlay>
          <Home {...homeprops} />
          {userrole != "teacher" && userid != "" ? <TableEnseignants handlesetTeacherid_select={handlesetTeacherid_select} dataconnected={dataconnected} handleData={handleData} userid={userid} isnotenseignant={isnotenseignant} /> : <div></div>}
          {userrole == "teacher" && userid != "" ? <TableMatieres handleDataMatiereEnseignant={handleDataMatiereEnseignant} {...homeprops} /> : <div></div>}
          {pageid == "mesetudiants" ? <CardMesEleves LoadDataUserForEnseignant={LoadDataUserForEnseignant} pageid={pageid} frameurl={frameurl} datamatieres={datamatieres} handleOpenVisio={handleOpenVisio} userid={userid} handleDataClasseEtudiants={handleDataClasseEtudiants} handleCardEleves={handleCardEleves} nb_student_cnx={nb_student_cnx} datastudent={datastudent}></CardMesEleves> : null}
          {pageid == "mesetudiantslabo" ? <CardMesEleves LoadDataUserForEnseignant={LoadDataUserForEnseignant} pageid={pageid} frameurl={frameurl} datamatieres={datamatieres} handleOpenVisio={handleOpenVisio} userid={userid} handleDataClasseEtudiants={handleDataClasseEtudiants} handleCardEleves={handleCardEleves} nb_student_cnx={nb_student_cnx} datastudent={datastudent}></CardMesEleves> : null}
          {/*pageid=="labo_local"?<iframe style={{border:0,width:'100%',height:'100%'}}  src={"http://labtice.com/data/mosaique.html?"+parampclocal}/>:null*/}
          {/*<TabsEnseignants {...homeprops}/>*/}
          {userrole != "teacher" && userid != '' ? <TabsDocuments _onUploadtext={_onUploadtext} handle_select_document={handle_select_document} forcematiere={forcematiere} recordingsbydate={recordingsbydate} dataclassesetudiants={dataclassesetudiants} handleSelectMatiere={handleSelectMatiere} data={data} {...homeprops} /> : <div></div>}
          {userrole == "teacher" && userid != '' ? <TabsDocumentsEnseignant dataclassesetudiants={dataclassesetudiants} handleSelectMatiere={handleSelectMatiere} {...homeprops} /> : <div></div>}
          <PanelLogout data={datamatieres} {...homeprops} />
          <span style={{ display: 'flex', flexWrap: 'wrap' }}>
            <CardOpenVisio teacherid={teacherid_select} {...homeprops} />
            <CardAteliers  {...homeprops} />
            <CardMesEnregistrements _onUploadtext={_onUploadtext}   {...mesenregistrementsprops} />
          </span>



        </div>
      </div> :
        <div>
          {isAdmin == 1 ? <div>

            <CardSuperAdmin onChangeIdentifiant={onChangeIdentifiant}></CardSuperAdmin>
            <Button onClick={(ev) => handleSendCreateUser(useridentifiantpassword.identifiant, useridentifiantpassword.identifiant, useridentifiantpassword.identifiant, useridentifiantpassword.password, "", "", useridentifiantpassword.etablissement, "superadmin")} disabled={useridentifiantpassword.etablissement == "" || useridentifiantpassword.identifiant == "" || useridentifiantpassword.password == ""}>Créé</Button>
          </div>

            : isAdmin == 2 ?
              <div>
                <CardAdminDistributeurs userid={userid} useretablissement={useretablissement} handleSendCnxAutoLogin={handleSendCnxAutoLogin} handleSendCreateAdmin={handleSendCreateAdmin}></CardAdminDistributeurs>
              </div>
              : isAdmin == 3 ?
                <div>
                  <CardAdminClients socketlabtice={socketlabtice} handleSendCreateEnseignant={handleSendCreateEnseignant} userid={userid} useretablissement={useretablissement} ></CardAdminClients>
                </div> : null}
        </div>


      }
    </div>
  );
}

export default App;

